<template>
  <div id="newReviewList" :class="{'review-detail-page': isReviewDetailPage}" class="page-layout"
       data-track="Reviews List - Landing Page">
    <!-- Header Section Begins -->
    <div class="level page-info-section">
      <div class="level-left page-layout-head">Review management</div>
    </div>
    <hr v-if="!isMobile" class="page-layout-horizontal-row"/>
    <!-- Header Section Ends -->

    <div
      :class="{'margin-bottom--12':!isReviewDetailPage && isDesktop, 'is-flex':!isReviewDetailPage, 'margin-right--15':isReviewDetailPage && isDesktop}">
      <div :class="{'filter-output-section':!isReviewDetailPage}">
        <div v-if="!isDesktop" class="is-clearfix filter-section--tablet">
          <template v-if="!isReviewDetailPage">
            <custom-dropdown-form
              :key="filterDd.key"
              :class="{'is-pulled-left': !isMobile}"
              :options="filterDd.options"
              class="filter-dd custom-dropdown custom-dropdown--small padding-right-0 margin-right-3"
              group="reviewsListFilterFormDd"
              label="Filters"
            />
            <date-select-filter v-if="filters.dateFilter.reviews_start_date"
                                :key="filters.dateFilter.key"
                                :class="{'is-pulled-left': !isMobile}"
                                :filter_items="filters.dateFilter.props"
                                :reviews_start_date="filters.dateFilter.reviews_start_date"
                                :styleProp="filters.dateFilter.styleProp"
                                class="custom-dropdown custom-dropdown--small padding-right-0"
                                @onDateChange="handleDateChange"/>
            <a :class="{'is-pulled-left': !isMobile, 'is-pulled-right': isMobile}"
               class="blue-link"
               data-track="Reviews List - Clear Filter link"
               href="#" @click.prevent="clearFilters">Clear filters</a>
          </template>
        </div>
        <div class="level filter-output-header">
          <template v-if="isReviewDetailPage">
            <a :class="{'font-size-14':!isMobile}" class="blue-link f12 text-underline-no"
               data-track="Reviews List - All reviews link"
               href="/reviews">
              <i class="fas fa-chevron-left margin-right-5"></i>
              <span class="text-underline">Back to all reviews</span>
            </a>
          </template>
          <template v-else>
            <div :class="{'is-clearfix':isMobile, 'has-text-right':isMobile}" class="level-left">
              <span :class="{'is-pulled-left':isMobile}" class="filter-output-header-text">
                <div v-if="reviewsList.isLoading" class="has-spinner has-spinner--inline">
                  <img
                    class="has-spinner__spinner"
                    src="/static/img/loaders/spinner.svg"
                  />
                </div>
                <template v-else>
                  {{ reviewsList.recordsCount }} Reviews found
                </template>
              </span>
            </div>
            <div v-if="isDesktop" class="level-right">
              <custom-dropdown
                :options="sortDdOpts"
                class="sort-dd"
                group="reviewsListSortDd"
              />
            </div>
          </template>
        </div>
        <div :class="{'pretty-scroll': !isDesktop}" :style="{'--height':reviewListContHeight}"
             class="filter-output-body">
          <div class="has-spinner">
            <img
              v-if="reviewsList.isLoading"
              class="has-spinner__spinner"
              src="/static/img/loaders/spinner.svg"
            />
            <template v-else>
              <div v-for="(review, index) in reviewsList.items"
                   :class="[`review--${review.channel}`, {'margin-bottom-20':!isReviewDetailPage && isDesktop && index === reviewsList.items.length-1}]"
                   class="review">
                <div class="is-flex">
                  <div v-if="!review.isRead" class="review-unread-mark"></div>
                  <div class="file-mobile">
                    <div :class="{'is-flex':!isMobile}">
                      <div>
                        <div>
                          <span class="has-text-weight-bold">
                            <span v-if="!isMobile" class="is-italic">Written by:</span>
                            {{ review.reviewerName }}
                          </span>
                          <span class="font-size-11">
                            <span class="valign-top">|</span> {{ review.datetime }}
                          </span>
                        </div>
                        <div v-if="isMobile" class="is-clearfix">
                          <rating
                            :stars="review.rating"
                            class="star-rating-review is-pulled-left"
                          ></rating>
                        </div>
                        <rating
                          v-else
                          :stars="review.rating"
                          class="star-rating-review"
                        ></rating>
                        <div v-if="isDesktop" :class="{'is-invisible':!isHpPlatformReview(review)}"
                             class="font-size-11">
                          NPS:
                          <template v-if="review.nps === 'pending'">
                            <span class="is-italic">Pending…</span>
                            <tooltip-new class="margin-left-4 is-inline-block" content-width="350px" :v2="true">
                              No net promoter score response has been received for this review
                            </tooltip-new>
                          </template>
                          <template v-else>{{ review.nps }}</template>
                        </div>
                      </div>
                      <div class="review-meta">
                        <div :class="{'margin-bottom-10': !isMobile, 'margin-bottom-7': isMobile}" class="margin-top-3">
                          <span>Status:</span>
                          <span v-if="review.isReported" class="review-reported-mark">
                            <img src="/static/img/reviews/report_flag.svg"/>
                            Reported
                          </span>
                          <span v-else-if="!review.isRead"
                                class="review-status-mark review-unreplied-mark">Unread</span>
                          <span v-else-if="!review.isReplied"
                                class="review-status-mark review-unreplied-mark">Unreplied</span>
                          <span v-else-if="!review.repliedToComments" class="review-status-mark review-unreplied-mark">Unreplied Comment</span>
                          <span v-else-if="review.isRead && review.isReplied && review.repliedToComments"
                                class="review-status-mark review-replied-mark">Replied</span>
                        </div>
                        <div :class="{'margin-bottom-10': Object.keys(review.branch).length}">
                          <span>Channel:</span>
                          <template v-if="isGooglePlatformReview(review)">
                            <img class="non-hp-source google-source" src="/static/img/social/google/google_channel_hq.png"/>
                            Google
                          </template>
                          <template v-else-if="isFacebookPlatformReview(review)">
                            <img class="non-hp-source" src="/static/img/social/fb/fb_channel.png"/>
                            Facebook
                          </template>
                          <template v-else-if="isHpPlatformReview(review)">
                            <img
                              class="hp-source"
                              src="/static/img/logo/favicon-16x16.png"
                            />
                            Hellopeter
                          </template>
                        </div>
                        <div v-if="!isFreeSubscription && isDesktop && Object.keys(review.branch).length">
                          Branch:
                          <span v-for="(branch, slug) in review.branch"
                                :class="{'capsule--no-del': branch.isLinkedFromQr}"
                                class="capsule">
                        {{ branch.value }}
                        <a v-if="!branch.isLinkedFromQr" data-track="Reviews List - Unlink Branch" href="#"
                           @click.prevent="unlinkBranch(slug, review)"><img
                          src="/static/img/reviews/capsule_x.svg"/></a>
                      </span>
                        </div>
                      </div>
                    </div>
                    <div :class="{'review-title-box--has-images':review.images.length}" class="review-title-box">
                      <review-attachments v-if="review.images.length" :attachments="review.images" class="image-list"/>
                      <div class="review-title">{{ review.title }}</div>
                      <div :class="{'margin-bottom-24': isDesktop, 'ellipses-new': !review.showDetails}"
                           class="review-body">
                        <div v-html="review.body"></div>
                      </div>
                    </div>
                    <template v-if="isDesktop">
                      <div v-if="!isFreeSubscription && Object.keys(review.tags).length" class="tags-list">
                        <span v-for="(tag, slug) in review.tags" class="capsule">
                          {{ tag }}
                          <a data-track="Reviews List - Unlink Tag" href="#"
                             @click.prevent="unlinkTag(slug, review)"><img
                            src="/static/img/reviews/capsule_x.svg"/></a>
                        </span>
                      </div>
                      <a v-if="!isReviewDetailPage && isHpPlatformReview(review)" class="blue-link"
                         data-track="Reviews List - Copy review link" href="#"
                         @click.prevent="copyLink(review.permalink)">Copy review link</a>
                      <div class="margin-top-10 is-clearfix">
                        <div v-if="!review.showDetails" class="is-pulled-right">
                          <div v-if="review.loadingDetails" class="has-spinner has-spinner--inline">
                            <img
                              class="has-spinner__spinner"
                              src="/static/img/loaders/spinner.svg"
                            />
                          </div>
                          <a
                            v-else
                            class="blue-link margin-right-15"
                            data-track="Reviews List - Show review details"
                            href="#"
                            @click.prevent="showReviewDetails(review)"
                          >Show more</a>
                        </div>

                        <v-popover
                          v-if="!isGooglePlatformReview(review) || (!review.replies.length && (!(review.permalink in reviewDetails) || !Object.keys(reviewDetails[review.permalink].replies).length))"
                          :autoHide="false"
                          :disabled="quickReply.openedPopoverIndex !== false && quickReply.openedPopoverIndex !== review.id"
                          class="is-inline-block"
                          container="#newReviewList"
                          placement="bottom-end"
                          popoverClass="reply-popover"
                          @show="resetQuickReplyForm(review)"
                          @apply-hide="resetReplyPopoverIndex">
                          <a class="review-action-btn" data-track="Reviews List - Quick Reply" href="#"
                             @click.prevent>Reply</a>

                          <popover-new slot="popover">
                            <template slot="header">
                              Reply
                            </template>

                            <div class="has-spinner">
                              <img
                                v-if="review.checkingCanReply"
                                class="has-spinner__spinner"
                                src="/static/img/loaders/spinner.svg"
                              />
                              <template v-else>
                                <template v-if="review.canReply === 'no'">
                                  <div v-if="isFreeSubscription" class="margin-bottom-50 pad-top-20">
                                    <img class="margin-right-15" src="/static/img/competitors/lock.svg"/>
                                    <a :href="subscUpgradeUrl" class="blue-link"
                                       data-track="Reviews List - Quick reply - Upgrade link">Upgrade</a>
                                    to reply now or wait for your monthly plan to renew.
                                  </div>
                                  <buy-credits v-else-if="!isAnnualSubscription" :buy="false"
                                               class="upgrade-msg-monthly">
                                    <template slot="header">
                                      You have no more reply credits for the month.
                                    </template>
                                    to reply now or wait for your monthly plan to renew.
                                  </buy-credits>
                                  <buy-credits v-else class="margin-bottom-20"/>
                                </template>
                                <div v-else-if="review.canReply === 'yes'" class="is-clearfix">
                                  <div class="pos-relative">
                                    <wysiwyg :ref="`quickReplyWysiwyg${review.permalink}`"
                                             v-model="quickReply.data.reply"
                                             :name="quickReply.data.reply"
                                             :pre-saved-responses="false"
                                             :shouldClear="true"
                                             :simpleEditor="!isHpPlatformReview(review)"
                                             :value="quickReply.data.reply"
                                             class="wysiwyg" @charLength="getCharLength($event, quickReply)"/>
                                    <saved-replies-popup
                                      @selected-saved-reply="setWysiwygValue(`quickReplyWysiwyg${review.permalink}`, $event)"/>
                                  </div>

                                  <div :class="{'flex-justify-end':isDesktop, 'flex-wrap-wrap': isMobile}"
                                       class="is-flex flex-align-centre">
                                    <template v-if="isProSubscription && isHpPlatformReview(review)">
                                      <div class="field margin-right-30">
                                        <input
                                          id="quickReplyPub"
                                          v-model="quickReply.data.replyType"
                                          :value="1"
                                          class="margin-right-15"
                                          type="radio"
                                        />
                                        <label for="quickReplyPub">Public reply</label>
                                      </div>
                                      <div class="field margin-right-30">
                                        <input
                                          id="quickReplyPriv"
                                          v-model="quickReply.data.replyType"
                                          :value="2"
                                          class="margin-right-15"
                                          type="radio"
                                        />
                                        <label for="quickReplyPriv">Private reply</label>
                                      </div>
                                    </template>
                                    <button
                                      :class="{'is-loading': quickReply.isProcessing, 'margin-left-auto': !isDesktop}"
                                      :disabled="quickReply.isProcessing || !quickReply.data.reply"
                                      class="button solid-btn"
                                      data-track="Reviews List - Quick reply - Reply submit"
                                      @click="showMaskingModal(quickReply)"
                                    >REPLY NOW
                                    </button>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </popover-new>
                        </v-popover>

                        <v-popover class="is-inline-block" container="#newReviewList" placement="bottom-end"
                                   @show="closeReplyPopover">
                          <a class="review-action-btn" data-track="Reviews List - Push" href="#" @click.prevent>Push</a>

                          <popover-new slot="popover" :width="332">
                            <template slot="header">
                              Push
                            </template>

                            <div
                              :class="{'margin-bottom-10': !isHpPlatformReview(review), 'margin-bottom-15': isHpPlatformReview(review)}"
                              data-track="Reviews List - Push - Create an Ad">
                              <a href="#" @click.prevent="createSocialAd(review.permalink)">
                                <img class="valign-middle margin-right-7 w-28" src="/static/img/reviews/plus.svg"/>
                                <span class="color-58595b">Create an Ad</span>
                              </a>
                            </div>
                            <social-sharing v-if="isHpPlatformReview(review)" :url="review.url" inline-template
                                            @open="shareOpen($event, review.permalink)" title="Check out this review on @hellopetercom">
                              <div>
                                <network network="facebook">
                                  <router-link class="margin-left-4 background-none" to="">
                                    <div class="margin-bottom-15" data-track="Reviews List - Push - Facebook">
                                      <a href="#">
                                        <img class="valign-middle margin-right-7 w-30" src="/static/img/social/fb/fb.png"/>
                                        <span class="color-58595b">Push to Facebook</span>
                                      </a>
                                    </div>
                                  </router-link>
                                </network>
                                <network network="twitter">
                                  <router-link class="margin-left-4 background-none" to="">
                                    <div class="margin-bottom-15" data-track="Reviews List - Push - Twitter">
                                      <a href="#">
                                        <img class="valign-middle margin-right-7 w-30"
                                             src="/static/img/social/twitter/twitter.svg"/>
                                        <span class="color-58595b">Push to X</span>
                                      </a>
                                    </div>
                                  </router-link>
                                </network>
                                <network network="linkedin">
                                  <router-link class="margin-left-4 background-none" to="">
                                    <div class="margin-bottom-10" data-track="Reviews List - Push - LinkedIn">
                                      <a href="#">
                                        <img class="valign-middle margin-right-7 w-30"
                                             src="/static/img/social/linkedin/linkedin2.png"/>
                                        <span class="color-58595b">Push to LinkedIn</span>
                                      </a>
                                    </div>
                                  </router-link>
                                </network>
                              </div>
                            </social-sharing>
                          </popover-new>
                        </v-popover>

                        <v-popover v-if="!review.isReported" :disabled="reportReview.popoverDisable"
                                   class="is-inline-block"
                                   container="#newReviewList" placement="bottom-end"
                                   @hide="resetReportForm"
                                   @show="closeReplyPopover">
                          <a class="review-action-btn" data-track="Reviews List - Report" href="#"
                             @click.prevent>Report</a>

                          <popover-new slot="popover" :width="332" class="report-popover">
                            <template slot="header">
                              Report review
                            </template>

                            <alert-message v-if="!isHpPlatformReview(review)" class="margin-bottom-0" type="warning">
                              This feature is not available to {{ review.channel | capitalize }} reviews.
                            </alert-message>
                            <template v-else>
                              <div class="margin-bottom-20">Why are you reporting this review?</div>

                              <div class="margin-bottom-12">
                                <input
                                  id="report1"
                                  v-model="reportReview.data.reason"
                                  class="margin-right-10"
                                  name="report"
                                  type="radio"
                                  value="5"
                                />
                                <label for="report1">The review is for a different business</label>
                              </div>
                              <div class="margin-bottom-12">
                                <input
                                  id="report2"
                                  v-model="reportReview.data.reason"
                                  class="margin-right-10"
                                  name="report"
                                  type="radio"
                                  value="8"
                                />
                                <label for="report2">The review is spam or a scam</label>
                              </div>
                              <div class="margin-bottom-12">
                                <input
                                  id="report3"
                                  v-model="reportReview.data.reason"
                                  class="margin-right-10"
                                  name="report"
                                  type="radio"
                                  value="4"
                                />
                                <label for="report3">The review is defamatory</label>
                              </div>
                              <div class="margin-bottom-12">
                                <input
                                  id="report4"
                                  v-model="reportReview.data.reason"
                                  class="margin-right-10"
                                  name="report"
                                  type="radio"
                                  value="3"
                                />
                                <label for="report4">The review is false or contains false information</label>
                              </div>
                              <div class="margin-bottom-18">
                                <input
                                  id="report5"
                                  v-model="reportReview.data.reason"
                                  class="margin-right-10"
                                  name="report"
                                  type="radio"
                                  value="6"
                                />
                                <label for="report5">Other</label>
                                <span v-if="reportReview.errors.review_reason"
                                      class="help is-danger has-text-weight-normal">{{
                                    reportReview.errors.review_reason[0]
                                  }}</span>
                              </div>

                              <div class="margin-bottom-5">Please give us more information to help us investigate:</div>
                              <div class="margin-bottom-10">
                                <textarea v-model="reportReview.data.info" class="v-textarea textarea"></textarea>
                                <span v-if="reportReview.errors.report_reason"
                                      class="help is-danger has-text-weight-normal">{{
                                    reportReview.errors.report_reason[0]
                                  }}</span>
                              </div>
                              <button
                                :class="{'is-loading': reportReview.isProcessing}"
                                :disabled="false"
                                class="button solid-btn is-fullwidth"
                                data-track="Reviews List - Report - Submit report form"
                                @click="reportAReview(review)"
                              >REPORT REVIEW
                              </button>
                            </template>
                          </popover-new>
                        </v-popover>

                        <v-popover :disabled="reviewTags.popoverDisable" class="is-inline-block"
                                   container="#newReviewList"
                                   placement="bottom-end"
                                   @hide="resetAddTagForm"
                                   @show="closeReplyPopover">
                          <a class="review-action-btn" data-track="Reviews List - Tags" href="#" @click.prevent>Tag</a>

                          <popover-new slot="popover" class="tag-popover">
                            <template slot="header">
                              Tags
                            </template>

                            <buy-credits v-if="isFreeSubscription" :buy="false" :header="false"
                                         class="margin-bottom-20">
                              to add tags to your review.
                            </buy-credits>

                            <div class="field is-grouped">
                              <p class="control is-expanded">
                                <input v-model="reviewTags.data"
                                       :disabled="reviewTags.isProcessing || isFreeSubscription" class="v-input input"
                                       placeholder="Create new tag"
                                       type="text">
                                <span v-if="reviewTags.errors.tag"
                                      class="help is-danger has-text-weight-normal">{{
                                    reviewTags.errors.tag[0]
                                  }}</span>
                              </p>
                              <p class="control">
                                <button
                                  :class="{'is-loading': reviewTags.isProcessing}"
                                  :disabled="reviewTags.isProcessing || !reviewTags.data || isFreeSubscription"
                                  class="button solid-btn"
                                  data-track="Reviews List - Tags - Submit Add tag"
                                  @click="createAndLinkTag(review)"
                                >ADD TAG
                                </button>
                              </p>
                            </div>
                            <div v-if="Object.keys(tagsList).length" class="margin-left--12 margin-top-15">
                          <span v-for="(tag, slug) in tagsList" v-if="!(slug in review.tags)"
                                :class="{'capsule--fade': isFreeSubscription}"
                                class="capsule capsule--no-del pointer"
                                data-track="Reviews List - Tags - Link tag and review link"
                                @click="linkTag(tag, review)">
                            {{ tag }}
                          </span>
                            </div>
                          </popover-new>
                        </v-popover>

                        <v-popover :disabled="reviewBranch.popoverDisable" class="is-inline-block"
                                   container="#newReviewList"
                                   placement="bottom-end" @hide="resetAddBranchForm"
                                   @show="closeReplyPopover">
                          <a class="review-action-btn" data-track="Reviews List - Branches" href="#"
                             @click.prevent>Branches</a>

                          <popover-new slot="popover" class="tag-popover branch-popover">
                            <template slot="header">
                              Branches
                            </template>

                            <buy-credits v-if="isFreeSubscription" :buy="false" :header="false"
                                         class="margin-bottom-20">
                              to add branches to your review.
                            </buy-credits>
                            <alert-message v-else-if="Object.keys(review.branch).length"
                                           class="margin-bottom-15 font-size-11"
                                           type="warning">
                              You can only link one branch to a review.
                            </alert-message>

                            <div class="field is-grouped">
                              <p class="control is-expanded">
                                <input v-model="reviewBranch.data"
                                       :disabled="reviewBranch.isProcessing || !!Object.keys(review.branch).length || isFreeSubscription"
                                       class="v-input input"
                                       placeholder="Create new branch"
                                       type="text">
                                <span v-if="reviewBranch.errors.branch"
                                      class="help is-danger has-text-weight-normal">{{
                                    reviewBranch.errors.branch[0]
                                  }}</span>
                              </p>
                              <p class="control">
                                <button
                                  :class="{'is-loading': reviewBranch.isProcessing}"
                                  :disabled="reviewBranch.isProcessing || !reviewBranch.data || !!Object.keys(review.branch).length || isFreeSubscription"
                                  class="button solid-btn"
                                  data-track="Reviews List - Branches - Submit add branch"
                                  @click="createAndLinkBranch(review)"
                                >ADD BRANCH
                                </button>
                              </p>
                            </div>
                            <div v-if="Object.keys(branchesList).length" class="margin-left--12 margin-top-15">
                          <span v-for="(branch, slug) in branchesList" v-if="!(slug in review.branch)"
                                :class="{'capsule--fade': Object.keys(review.branch).length || isFreeSubscription}"
                                class="capsule capsule--no-del pointer"
                                data-track="Reviews List - Branches - Link branch and review link"
                                @click="linkBranch(branch.value, review)">
                            {{ branch.value }}
                          </span>
                            </div>
                          </popover-new>
                        </v-popover>

                        <v-popover :disabled="reviewNote.popoverDisable" class="is-inline-block"
                                   container="#newReviewList"
                                   placement="bottom-start" popoverClass="add-note-popover"
                                   @hide="resetAddNoteForm"
                                   @show="closeReplyPopover">
                          <a class="review-action-btn" data-track="Reviews List - Add Notes form" href="#"
                             @click.prevent>Add Note</a>

                          <popover-new slot="popover" :width="332">
                            <template slot="header">
                              Add note
                            </template>

                            <buy-credits v-if="!isProSubscription" :buy="false" :header="false"
                                         class="margin-bottom-20">
                              to add notes to your review.
                            </buy-credits>

                            <textarea v-model="reviewNote.data"
                                      :disabled="reviewNote.isProcessing || !isProSubscription"
                                      class="v-textarea textarea margin-bottom-15"
                                      placeholder="Type note here…"></textarea>
                            <button
                              :class="{'is-loading': reviewNote.isProcessing}"
                              :disabled="reviewNote.isProcessing || !reviewNote.data || !isProSubscription"
                              class="button solid-btn is-fullwidth"
                              data-track="Reviews List - Submit Add Notes form"
                              @click="addNote(review.permalink)"
                            >ADD NOTE
                            </button>
                          </popover-new>
                        </v-popover>
                      </div>
                    </template>
                    <template v-else>
                      <div v-if="!review.showDetails">
                        <div v-if="review.loadingDetails" class="has-spinner has-spinner--inline">
                          <img
                            class="has-spinner__spinner"
                            src="/static/img/loaders/spinner.svg"
                          />
                        </div>
                        <a
                          v-else
                          class="blue-link"
                          data-track="Reviews List - Show review details"
                          href="#"
                          @click.prevent="showReviewDetails(review)"
                        >Show more</a>
                      </div>
                      <a v-if="!review.isReported" class="report-review" data-track="Reviews List - Report"
                         href="#" @click.prevent="openReportReviewModal(review)">
                        <img class="margin-right-7" src="/static/img/reviews/report_flag_dark.svg"/>
                        Report this review
                      </a>
                    </template>
                  </div>
                </div>
                <div v-if="review.showDetails" class="review-details-box">
                  <div class="level review-details-header">
                    <div :class="{'is-flex':isMobile && isHpPlatformReview(review)}"
                         class="level-left has-text-weight-bold">
                      <template v-if="isHpPlatformReview(review)">
                        <avatar :size="30" :username="review.reviewerName"
                                class="margin-right-8"></avatar>
                      </template>
                      <template v-else-if="isGooglePlatformReview(review)">
                        <img class="margin-right-7 valign-middle" src="/static/img/social/google/google_logo.png"/>
                      </template>
                      <template v-else-if="isFacebookPlatformReview(review)">
                        <img class="margin-right-7 valign-middle" src="/static/img/social/fb/fb_logo.png"/>
                      </template>
                      {{ review.reviewerName }}
                    </div>
                    <template v-if="isDesktop && isHpPlatformReview(review)">
                      <div v-if="!review.isStamped" class="level-right">
                        <img class="margin-right-15" src="/static/img/competitors/lock.svg"/>
                        <span class="color-blue text-underline pointer">View Reviewer History</span>
                      </div>
                      <a v-else class="blue-link level-right"
                         data-track="Reviews List - View user history link"
                         href="#" @click.prevent="openUserHistoryModal(review)">View Reviewer History</a>
                    </template>
                  </div>
                  <div v-if="isHpPlatformReview(review)" class="review-author-details">
                    <template v-if="review.isStamped">
                      <div v-if="reviewDetails[review.permalink].author.fullName" class="is-flex">
                        <div class="review-author-detail-col">Full name:</div>
                        <div>{{ reviewDetails[review.permalink].author.fullName }}</div>
                      </div>
                      <div v-if="reviewDetails[review.permalink].author.id" class="is-flex">
                        <div class="review-author-detail-col">ID:</div>
                        <div>{{ reviewDetails[review.permalink].author.id }}</div>
                      </div>
                      <div v-if="reviewDetails[review.permalink].author.email" class="is-flex">
                        <div class="review-author-detail-col">Email:</div>
                        <div>{{ reviewDetails[review.permalink].author.email }}</div>
                      </div>
                      <div v-if="reviewDetails[review.permalink].author.mobile" class="is-flex">
                        <div class="review-author-detail-col">Mobile:</div>
                        <div>{{ reviewDetails[review.permalink].author.mobile }}</div>
                      </div>
                      <div v-if="reviewDetails[review.permalink].source" class="is-flex">
                        <div class="review-author-detail-col">Review source:</div>
                        <div>{{ reviewDetails[review.permalink].source }}</div>
                      </div>
                      <div v-if="reviewDetails[review.permalink].ref" class="is-flex">
                        <div class="review-author-detail-col">Ref number:</div>
                        <div>{{ reviewDetails[review.permalink].ref }}</div>
                      </div>
                      <div v-if="reviewDetails[review.permalink].incidPlace" class="is-flex">
                        <div class="review-author-detail-col">Place of incident:</div>
                        <div>{{ reviewDetails[review.permalink].incidPlace }}</div>
                      </div>
                    </template>
                    <template v-else-if="review.canReply === 'yes'">
                      <div v-if="isFreeSubscription" class="upgrade-msg">
                        <img class="margin-right-15" src="/static/img/competitors/lock.svg"/>
                        <a :href="subscUpgradeUrl" class="blue-link"
                           data-track="Reviews List - Review details - Upgrade link">Upgrade</a>
                        to gain access to more user details.
                      </div>
                      <buy-credits v-else-if="!isAnnualSubscription" :buy="false" class="upgrade-msg-monthly">
                        <template slot="header">
                          You have no more review credits for the month.
                        </template>
                        to view contact details now or wait for your monthly plan to renew.
                      </buy-credits>
                      <buy-credits v-else class="upgrade-msg-annually">
                        <template slot="header">
                          You have no more review credits remaining.
                        </template>
                        or purchase review credits to view user contact details now.
                      </buy-credits>
                    </template>
                    <template v-else-if="review.canReply === 'no'">
                      <div v-if="isFreeSubscription" class="upgrade-msg">
                        <img class="margin-right-15" src="/static/img/competitors/lock.svg"/>
                        <a :href="subscUpgradeUrl" class="blue-link"
                           data-track="Reviews List - Review details - Upgrade link">Upgrade</a>
                        to gain access to more user details and to reply or wait for your monthly plan to renew.
                      </div>
                      <buy-credits v-else-if="!isAnnualSubscription" :buy="false" class="upgrade-msg-monthly">
                        <template slot="header">
                          You have no more review credits for the month.
                        </template>
                        to view contact details and to reply or wait for your monthly plan to renew.
                      </buy-credits>
                      <buy-credits v-else class="upgrade-msg-annually">
                        <template slot="header">
                          You have no more review credits remaining.
                        </template>
                        or purchase review credits to view contact details and to reply.
                      </buy-credits>
                    </template>
                  </div>
                  <div class="review-replies">
                    <template v-for="reply in reviewDetails[review.permalink].replies">
                      <div
                        :class="{'biz-reply':reply.author.type === 'biz', 'author-reply':reply.author.type === 'author'}">
                        <div class="level margin-bottom-10">
                          <div
                            :class="{'is-flex':isMobile && isHpPlatformReview(review) && reply.author.type !== 'biz'}"
                            class="level-left font-size-14 has-text-weight-bold">
                            <template v-if="reply.author.type === 'biz'">
                              {{ bizName }}’s
                            </template>
                            <template v-else>
                              <template v-if="isHpPlatformReview(review)">
                                <avatar :size="30" :username="review.reviewerName" class="margin-right-8"></avatar>
                              </template>
                              <template v-else-if="isGooglePlatformReview(review)">
                                <img class="margin-right-7 valign-middle" src="/static/img/social/google/google_logo.png"/>
                              </template>
                              <template v-else-if="isFacebookPlatformReview(review)">
                                <img class="margin-right-7 valign-middle" src="/static/img/social/fb/fb_logo.png"/>
                              </template>
                              {{ reply.author.name }}’s
                            </template>
                            reply
                            <template v-if="reply.type === 'private'">
                              <span class="capsule capsule--no-del reply-type-capsule">Private Reply</span>
                            </template>
                          </div>
                          <div class="level-right is-italic">
                            <template v-if="isDesktop && reply.author.type === 'biz'">
                              {{ reply.author.name }}
                            </template>
                            Replied at: {{ reply.datetime }}
                          </div>
                        </div>
                        <div :key="globalKey">
                          <template v-if="!reply.editMode">
                            <div class="margin-bottom-2" v-html="reply.body"></div>
                            <!--                            <template v-if="isHpPlatformReview(review)">
                                                          <div class="margin-bottom-2" v-html="reply.body"></div>
                                                        </template>
                                                        <template v-else>
                                                          <div class="margin-bottom-2" v-text="reply.body"></div>
                                                        </template>-->

                            <div
                              v-if="reply.author.type === 'biz' && (isHpPlatformReview(review) || isGooglePlatformReview(review))"
                              class="has-text-right">
                              <a class="blue-link"
                                 data-track="Reviews List - Edit reply link"
                                 href="#" @click.prevent="showReplyEdit(reply, review)">Edit</a>
                              <a v-if="isHpPlatformReview(review)"
                                 class="blue-link margin-left-17"
                                 data-track="Reviews List - Delete reply link"
                                 href="#" @click.prevent="openDeleteReplyModal(review.permalink, reply.id)">Delete</a>
                            </div>
                          </template>
                          <template v-else-if="reply.author.type === 'biz'">
                            <div class="pos-relative">
                              <wysiwyg :ref="`editReplyWysiwyg${reply.id}-${review.permalink}`"
                                       v-model="editReply[`reply-${reply.id}-${review.permalink}`].data.reply"
                                       :name="editReply[`reply-${reply.id}-${review.permalink}`].data.reply"
                                       :pre-saved-responses="false"
                                       :shouldClear="true"
                                       :simpleEditor="!isHpPlatformReview(review)"
                                       :value="editReply[`reply-${reply.id}-${review.permalink}`].data.reply"
                                       class="wysiwyg"
                                       @charLength="updateReplyKey(editReply[`reply-${reply.id}-${review.permalink}`])"/>
                              <saved-replies-popup :offset="isMobile ? -280 : 8" placement="left-end"
                                                   @selected-saved-reply="setWysiwygValue(`addReplyWysiwyg${review.permalink}`, $event)"/>
                            </div>
                            <div class="has-text-right">
                              <a class="blue-link margin-right-17"
                                 data-track="Reviews List - Cancel Edit reply link"
                                 href="#" @click.prevent="hideReplyEdit(reply)">Cancel</a>
                              <a :key="editReply.key"
                                 :class="{'disabled':editReply[`reply-${reply.id}-${review.permalink}`].isProcessing || !editReply[`reply-${reply.id}-${review.permalink}`].data.reply}"
                                 class="blue-link"
                                 data-track="Reviews List - Save Edit reply form"
                                 href="#"
                                 @click.prevent="postReplyEdit(editReply[`reply-${reply.id}-${review.permalink}`], reply)">Save</a>
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div v-if="isHpPlatformReview(review) && (review.canReply === 'yes' || review.isStamped)"
                       class="reply-box">
                    <div v-if="review.checkingCanReply" class="has-spinner">
                      <img
                        class="has-spinner__spinner"
                        src="/static/img/spinner.svg"
                      />
                    </div>
                    <template v-else-if="review.canReply === 'yes'">
                      <div class="font-size-14">Add your reply</div>
                      <div class="pos-relative">
                        <wysiwyg :ref="`addReplyWysiwyg${review.permalink}`"
                                 v-model="newReply[review.permalink].data.reply"
                                 :name="newReply[review.permalink].data.reply"
                                 :pre-saved-responses="false"
                                 :shouldClear="true"
                                 :value="newReply[review.permalink].data.reply"
                                 class="wysiwyg" @charLength="getCharLength($event, newReply[review.permalink])"/>
                        <saved-replies-popup :offset="isMobile ? -280 : 8" placement="left-end"
                                             @selected-saved-reply="setWysiwygValue(`addReplyWysiwyg${review.permalink}`, $event)"/>
                      </div>
                      <div :key="newReply.key" :class="{'flex-justify-end':isDesktop, 'flex-wrap-wrap': isMobile}"
                           class="is-flex flex-align-centre">
                        <template v-if="isProSubscription && isHpPlatformReview(review)">
                          <div class="field margin-right-30">
                            <input
                              :id="`replyPub-${review.permalink}`"
                              v-model="newReply[review.permalink].data.replyType"
                              :value="1"
                              class="margin-right-15"
                              type="radio"
                              @change="updateReplyKey(newReply[review.permalink])"
                            />
                            <label :for="`replyPub-${review.permalink}`">Public reply</label>
                          </div>
                          <div class="field margin-right-30">
                            <input
                              :id="`replyPriv-${review.permalink}`"
                              v-model="newReply[review.permalink].data.replyType"
                              :value="2"
                              class="margin-right-15"
                              type="radio"
                              @change="updateReplyKey(newReply[review.permalink])"
                            />
                            <label :for="`replyPriv-${review.permalink}`">Private reply</label>
                          </div>
                        </template>
                        <button
                          :class="{'is-loading': newReply[review.permalink].isProcessing, 'margin-left-auto': !isDesktop}"
                          :disabled="newReply[review.permalink].isProcessing || !newReply[review.permalink].data.reply"
                          class="button solid-btn"
                          data-track="Reviews List - Reply submit"
                          @click="showMaskingModal(newReply[review.permalink])"
                        >REPLY NOW
                        </button>
                      </div>
                    </template>
                    <template v-else-if="review.canReply === 'no' && review.isStamped">
                      <buy-credits v-if="isFreeSubscription || !isAnnualSubscription" :buy="false" class="upgrade-msg">
                        <template slot="header">
                          You have no more reply credits for the month.
                        </template>
                        to reply now or wait for your monthly plan to renew.
                      </buy-credits>
                      <buy-credits v-else class="upgrade-msg-annually"/>
                    </template>
                  </div>
                  <div
                    v-else-if="isFacebookPlatformReview(review) || (isGooglePlatformReview(review) && !Object.keys(reviewDetails[review.permalink].replies).length)"
                    class="reply-box">
                    <div class="font-size-14">Add your reply</div>
                    <div class="pos-relative">
                      <wysiwyg :ref="`addReplyWysiwyg${review.permalink}`"
                               v-model="newReply[review.permalink].data.reply"
                               :name="newReply[review.permalink].data.reply"
                               :pre-saved-responses="false"
                               :shouldClear="true"
                               :simpleEditor="true"
                               :value="newReply[review.permalink].data.reply"
                               class="wysiwyg" @charLength="getCharLength($event, newReply[review.permalink])"/>
                      <saved-replies-popup :offset="isMobile ? -280 : 8" placement="left-end"
                                           @selected-saved-reply="setWysiwygValue(`addReplyWysiwyg${review.permalink}`, $event)"/>
                    </div>
                    <div :key="newReply.key" class="is-flex flex-justify-end flex-align-centre">
                      <button
                        :class="{'is-loading': newReply[review.permalink].isProcessing}"
                        :disabled="newReply[review.permalink].isProcessing || !newReply[review.permalink].data.reply"
                        class="button solid-btn"
                        data-track="Reviews List - Reply submit"
                        @click="showMaskingModal(newReply[review.permalink])"
                      >REPLY NOW
                      </button>
                    </div>
                  </div>
                  <div v-if="isProSubscription && !isMobile"
                       :class="{'margin-bottom-15':isDesktop, 'margin-bottom-10':!isDesktop}">
                    <div class="review-notes-head">Team notes</div>
                    <div v-if="!reviewDetails[review.permalink].teamNotes.length" class="review-note">
                      <i>No team notes</i>
                    </div>
                    <template v-else>
                      <div v-for="note in reviewDetails[review.permalink].teamNotes" class="review-note">
                        <div :class="{'is-flex': isMobile}"
                             class="level margin-bottom-10 has-text-weight-bold is-italic">
                          <div class="level-left">{{ note.author }}</div>
                          <div class="level-right">{{ note.datetime }}</div>
                        </div>
                        <div>{{ note.body }}</div>
                      </div>
                    </template>
                  </div>
                  <div v-if="!isReviewDetailPage" :class="{'font-size-14':isDesktop, 'font-size-12':!isDesktop}"
                       class="has-text-right">
                    <a class="blue-link f12"
                       data-track="Reviews List - Hide review details link"
                       href="#" @click.prevent="hideReviewDetails(review)">Show less</a>
                  </div>
                </div>
                <div v-if="isTablet && !isReviewDetailPage" class="review-separator">
                  <div></div>
                </div>
              </div>
              <div v-if="!isReviewDetailPage" :class="{'margin-bottom-20':isDesktop}" class="level level-right">
                <paginator :canUpdateUrl="false" :dataSet="reviewsList.paging" class="reviewPagination"
                           @changed="loadReviewsList"></paginator>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div v-if="isDesktop && !isReviewDetailPage" class="filter-section">
        <div class="filter-search-module">
          <search-field :value="filters.string" @input="filterByString"/>

          <div class="level filter-search-module-foot">
            <div class="level-left has-text-weight-bold">Filters</div>
            <div class="level-right">
              <a class="blue-link" data-track="Reviews List - Clear Filter link"
                 href="#" @click.prevent="clearFilters">Clear filters</a>
            </div>
          </div>
        </div>

        <div class="filter-date-module">
          <div class="has-text-weight-bold">Date range</div>
          <date-select-filter v-if="filters.dateFilter.reviews_start_date"
                              :key="filters.dateFilter.key"
                              :filter_items="filters.dateFilter.props"
                              :reviews_start_date="filters.dateFilter.reviews_start_date"
                              :styleProp="filters.dateFilter.styleProp"
                              class="custom-dropdown custom-dropdown--small padding-top-0 padding-right-0"
                              @onDateChange="handleDateChange"/>
        </div>

        <accordion class="filter-module-with-checkbox filter-status-module" title="Status">
          <div>
            <colored-checkbox
              :is-checked="filters.status.includes('unreplied')"
              class="margin-right-15 margin-bottom-10"
              data-track="Reviews List - Status Filters - Unreplied Reviews"
              @cb-toggle="statusFilterToggle($event, 'unreplied')">
              <span class="checkbox-label">Unreplied Reviews</span>
            </colored-checkbox>
          </div>

          <div>
            <colored-checkbox
              :is-checked="filters.status.includes('unread')"
              class="margin-right-15 margin-bottom-10"
              data-track="Reviews List - Status Filters - Unread"
              @cb-toggle="statusFilterToggle($event, 'unread')">
              <span class="checkbox-label">Unread</span>
            </colored-checkbox>
            <tooltip-new class="is-inline-block" content-width="350px" pos="left" :v2="true">
              This filter displays all your unread reviews as well as unreplied comments left by reviewers
            </tooltip-new>
          </div>

          <div>
            <colored-checkbox
              :is-checked="filters.status.includes('unreplied_comment')"
              class="margin-right-15 margin-bottom-10"
              data-track="Reviews List - Status Filters - Unreplied Comments"
              @cb-toggle="statusFilterToggle($event, 'unreplied_comment')">
              <span class="checkbox-label">Unreplied Comments</span>
            </colored-checkbox>
            <tooltip-new class="is-inline-block" content-width="350px" pos="left" :v2="true">
              This filter displays reviews where the last response is from the reviewer
            </tooltip-new>
          </div>

          <div>
            <colored-checkbox
              :is-checked="filters.status.includes('reported')"
              class="margin-right-15 margin-bottom-10"
              data-track="Reviews List - Status Filters - Reported"
              @cb-toggle="statusFilterToggle($event, 'reported')">
              <span class="checkbox-label">Reported</span>
            </colored-checkbox>
          </div>
        </accordion>

        <accordion class="filter-module-with-checkbox filter-star-module" title="Star rating">
          <div v-for="rating in ratings" class="level margin-bottom-1">
            <colored-checkbox
              :is-checked="filters.rating.includes(rating.rating)"
              class="margin-right-15 margin-bottom-10 level-left"
              data-track="Reviews List - Star rating Filters"
              @cb-toggle="ratingFilterToggle($event, rating.rating)">
              <span class="checkbox-label">
                {{ rating.rating }} Star
                <rating
                  :stars="rating.rating"
                  class="font-size-5 star-rating-filter"
                ></rating>
              </span>
            </colored-checkbox>
            <div class="level-right">{{ rating.count }} Reviews</div>
          </div>
        </accordion>

        <accordion class="filter-module-with-checkbox filter-star-module" title="NPS Responses">
          <div class="level margin-bottom-1">
            <colored-checkbox
              :is-checked="filters.nps.includes('promotors')"
              class="margin-right-15 margin-bottom-10 level-left"
              data-track="Reviews List - NPS Filters - Promotors"
              @cb-toggle="npsFilterToggle($event, 'promotors')">
              <span class="checkbox-label">
                <img class="margin-right-7 " src="/static/img/reviews/promoters_small.svg"/>
                Promotors (9-10)
              </span>
            </colored-checkbox>
            <div class="level-right">{{ nps.promotors }} Responses</div>
          </div>

          <div class="level margin-bottom-1">
            <colored-checkbox
              :is-checked="filters.nps.includes('passives')"
              class="margin-right-15 margin-bottom-10 level-left"
              data-track="Reviews List - NPS Filters - Passives"
              @cb-toggle="npsFilterToggle($event, 'passives')">
              <span class="checkbox-label">
                <img class="margin-right-7 " src="/static/img/reviews/passives_small.svg"/>
                Passives (7-8)
              </span>
            </colored-checkbox>
            <div class="level-right">{{ nps.passives }} Responses</div>
          </div>

          <div class="level margin-bottom-1">
            <colored-checkbox
              :is-checked="filters.nps.includes('detractors')"
              class="margin-right-15 margin-bottom-10 level-left"
              data-track="Reviews List - NPS Filters - Detractors"
              @cb-toggle="npsFilterToggle($event, 'detractors')">
              <span class="checkbox-label">
                <img class="margin-right-7 " src="/static/img/reviews/detractors_small.svg"/>
                Detractors (0-6)
              </span>
            </colored-checkbox>
            <div class="level-right">{{ nps.detractors }} Responses</div>
          </div>
        </accordion>

        <accordion class="filter-module-with-checkbox" title="Channel">
          <channel-manage @channel-manage-toggle="channelFilterToggle($event.checked, $event.channel)"/>
        </accordion>

        <accordion :key="sourcesListKey" class="filter-module-with-checkbox" title="Source">
          <div v-for="(source, slug) in sourcesList">
            <colored-checkbox
              :is-checked="filters.source.includes(slug)"
              class="margin-right-15 margin-bottom-10"
              data-track="Reviews List - Source Filters"
              @cb-toggle="sourceFilterToggle($event, slug)">
              <span class="checkbox-label">{{ source }}</span>
            </colored-checkbox>
          </div>
        </accordion>

        <accordion v-if="!isFreeSubscription" class="filter-module-with-checkbox" title="Tags">
          <div v-if="!Object.keys(tagsList).length">
            <colored-checkbox
              :isDisabled="true"
              class="margin-right-15 margin-bottom-10">
              <span class="checkbox-label"><i>No tags added</i></span>
            </colored-checkbox>
          </div>
          <template v-else>
            <div v-for="(tag, slug) in tagsListFirst5" class="is-clearfix showOnHover">
              <colored-checkbox
                :is-checked="filters.tags.includes(slug)"
                class="margin-right-15 margin-bottom-10" data-track="Reviews List - Tag Filters"
                @cb-toggle="tagFilterToggle($event, slug)">
                <span class="checkbox-label">{{ tag }}</span>
              </colored-checkbox>
              <span :class="{'is-hidden': reviewTags.tagToEdit !== tag}" class="is-pulled-right margin-right-25">
                <v-popover :disabled="reviewTags.popoverDisable" class="is-inline-block" container="#newReviewList"
                           offset="179"
                           placement="left-start"
                           @hide="resetAddTagForm"
                           @apply-show="populateTagEdit(tag)">
                  <a class="blue-link margin-right-10" data-track="Reviews List - Tag Filter - Edit link" href="#"
                     @click.prevent>Edit</a>

                  <popover-new slot="popover" :width="332" class="tag-popover edit-tag-popover">
                    <template slot="header">
                      Rename Tag
                    </template>

                    <div class="edit-tag-popover__para">Rename your tag here:</div>
                    <div class="control">
                      <input v-model="reviewTags.data" :disabled="reviewTags.isProcessing" class="v-input input"
                             type="text">
                      <span v-if="reviewTags.errors.tag"
                            class="help is-danger has-text-weight-normal">{{
                          reviewTags.errors.tag[0]
                        }}</span>
                    </div>
                    <div class="control has-text-centered">
                      <p :class="{'edit-tag-popover__msg--hidden': !reviewTags.isSuccess}"
                         class="color-green edit-tag-popover__msg">Successfully renamed</p>
                      <button
                        :class="{'is-loading': reviewTags.isProcessing}"
                        :disabled="reviewTags.data === tag || reviewTags.isProcessing || !reviewTags.data"
                        class="button solid-btn"
                        data-track="Reviews List - Tag Filter - Edit form submit"
                        @click="renameTag(slug)"
                      >RENAME TAG</button>
                    </div>
                  </popover-new>
                </v-popover>
                <a class="blue-link" data-track="Reviews List - Tag Filter - Delete link" href="#"
                   @click.prevent="openDeleteTagModal('tag', slug, tag)">Delete</a>
              </span>
            </div>
            <div v-if="Object.keys(tagsList).length > 5">
              <v-popover container="#newReviewList" offset="20" placement="left-start">
                <div>
                  <a class="blue-link"
                     data-track="Reviews List - Tag Filter - More link"
                     href="#" @click.prevent="">[+]&nbsp;&nbsp;&nbsp;&nbsp;{{ Object.keys(tagsList).length - 5 }}
                    more</a>
                </div>

                <popover-new slot="popover" :width="878" class="branch-filter-popover">
                  <div class="select-all">
                    <colored-checkbox
                      data-track="Reviews List - Tag Filters"
                      @cb-toggle="tagFilterToggle($event)">
                      <span class="checkbox-label">Select All</span>
                    </colored-checkbox>
                  </div>

                  <div class="branch-filter-popover__list">
                    <div v-for="(tag, slug) in tagsList" class="column">
                      <div class="is-clearfix showOnHover">
                        <colored-checkbox
                          :is-checked="filters.tags.includes(slug)"
                          class="margin-bottom-10" data-track="Reviews List - Tag Filters"
                          @cb-toggle="tagFilterToggle($event, slug)">
                          <span class="checkbox-label">{{ tag }}</span>
                        </colored-checkbox>
                        <span class="is-pulled-right is-hidden">
                              <v-popover :disabled="reviewTags.popoverDisable" class="is-inline-block"
                                         container="#newReviewList"
                                         offset="0"
                                         placement="left-start"
                                         @hide="resetAddTagForm"
                                         @show="populateTagEdit(tag)">
                                <a class="blue-link" data-track="Reviews List - Tag Filter popup - Edit link" href="#"
                                   @click.prevent>
                                  <i class="far fa-edit"></i>
                                </a>

                                <popover-new slot="popover" :width="332" class="tag-popover edit-tag-popover">
                                  <template slot="header">
                                    Rename Tag
                                  </template>

                                  <div class="edit-tag-popover__para">Rename your tag here:</div>
                                  <div class="control">
                                    <input v-model="reviewTags.data" :disabled="reviewTags.isProcessing"
                                           class="v-input input"
                                           type="text">
                                    <span v-if="reviewTags.errors.tag"
                                          class="help is-danger has-text-weight-normal">{{
                                        reviewTags.errors.tag[0]
                                      }}</span>
                                  </div>
                                  <div class="control has-text-centered">
                                    <p :class="{'edit-tag-popover__msg--hidden': !reviewTags.isSuccess}"
                                       class="color-green edit-tag-popover__msg">Successfully renamed</p>
                                    <button
                                      :class="{'is-loading': reviewTags.isProcessing}"
                                      :disabled="reviewTags.data === tag || reviewTags.isProcessing || !reviewTags.data"
                                      class="button solid-btn"
                                      data-track="Reviews List - Tag Filter popup - Edit form submit"
                                      @click="renameTag(slug)"
                                    >RENAME TAG</button>
                                  </div>
                                </popover-new>
                              </v-popover>
                              <span class="color-blue margin-right-3">|</span>
                              <a class="blue-link" data-track="Reviews List - Tag Filter popup - Delete link" href="#"
                                 @click.prevent="openDeleteTagModal('tag', slug, tag)">
                                <i class="far fa-trash-alt"></i>
                              </a>
                            </span>
                      </div>
                    </div>
                  </div>
                </popover-new>
              </v-popover>
            </div>
          </template>
        </accordion>

        <accordion v-if="!isFreeSubscription" class="filter-module-with-checkbox" title="Branches">
          <div v-if="!Object.keys(branchesList).length">
            <colored-checkbox
              :isDisabled="true"
              class="margin-right-15 margin-bottom-10">
              <span class="checkbox-label"><i>No branches added</i></span>
            </colored-checkbox>
          </div>
          <template v-else>
            <div v-for="(branch, slug) in branchesListFirst5" class="is-clearfix showOnHover">
              <colored-checkbox
                :is-checked="filters.branches.includes(slug)"
                class="margin-right-15 margin-bottom-10"
                data-track="Reviews List - Branch Filters"
                @cb-toggle="branchFilterToggle($event, slug)">
                <span class="checkbox-label">{{ branch.value }}</span>
              </colored-checkbox>
              <span v-if="branch.isCustom"
                    :class="{'is-hidden': reviewBranch.branchToEdit !== branch.value}"
                    class="is-pulled-right margin-right-25">
                <v-popover :disabled="reviewBranch.popoverDisable" class="is-inline-block" container="#newReviewList"
                           offset="179"
                           placement="left-start"
                           @hide="resetAddBranchForm"
                           @apply-show="populateBranchEdit(branch.value)">
                  <a class="blue-link margin-right-10" data-track="Reviews List - Branch Filter - Edit link" href="#"
                     @click.prevent>Edit</a>

                  <popover-new slot="popover" :width="332" class="tag-popover edit-tag-popover">
                    <template slot="header">
                      Rename Branch
                    </template>

                    <div class="edit-tag-popover__para">Rename your branch here:</div>
                    <div class="control">
                      <input v-model="reviewBranch.data" :disabled="reviewBranch.isProcessing" class="v-input input"
                             type="text">
                      <span v-if="reviewBranch.errors.tag"
                            class="help is-danger has-text-weight-normal">{{
                          reviewBranch.errors.tag[0]
                        }}</span>
                    </div>
                    <div class="control has-text-centered">
                      <p :class="{'edit-tag-popover__msg--hidden': !reviewBranch.isSuccess}"
                         class="color-green edit-tag-popover__msg">Successfully renamed</p>
                      <button
                        :class="{'is-loading': reviewBranch.isProcessing}"
                        :disabled="reviewBranch.data === branch.value || reviewBranch.isProcessing || !reviewBranch.data"
                        class="button solid-btn"
                        data-track="Reviews List - Branch Filter - Edit form submit"
                        @click="renameBranch(slug)"
                      >RENAME BRANCH</button>
                    </div>
                  </popover-new>
                </v-popover>
                <a class="blue-link" data-track="Reviews List - Branch Filter - Delete link" href="#"
                   @click.prevent="openDeleteTagModal('branch', slug, branch.value)">Delete</a>
              </span>
            </div>
            <div v-if="Object.keys(branchesList).length > 5">
              <v-popover container="#newReviewList" offset="20" placement="left-start">

                <a class="blue-link" data-track="Reviews List - Branch Filter - More link"
                   href="#" @click.prevent>[+]&nbsp;&nbsp;&nbsp;&nbsp;{{ Object.keys(branchesList).length - 5 }}
                  more</a>

                <popover-new slot="popover" :width="878" class="branch-filter-popover">
                  <div class="select-all">
                    <colored-checkbox
                      data-track="Reviews List - Branch Filters"
                      @cb-toggle="branchFilterToggle($event)">
                      <span class="checkbox-label">Select All</span>
                    </colored-checkbox>
                  </div>

                  <div class="branch-filter-popover__list">
                    <div v-for="(branch, slug) in branchesList" class="column">
                      <div class="is-clearfix showOnHover">
                        <colored-checkbox
                          :is-checked="filters.branches.includes(slug)"
                          class="margin-bottom-10"
                          data-track="Reviews List - Branch Filters"
                          @cb-toggle="branchFilterToggle($event, slug)">
                          <span class="checkbox-label">{{ branch.value }}</span>
                        </colored-checkbox>
                        <span v-if="branch.isCustom" class="is-pulled-right is-hidden">
                            <v-popover :disabled="reviewBranch.popoverDisable" class="is-inline-block"
                                       container="#newReviewList"
                                       offset="0"
                                       placement="left-start"
                                       @hide="resetAddBranchForm"
                                       @show="populateBranchEdit(branch.value)">
                              <a class="blue-link" data-track="Reviews List - Branch Filter popup - Edit link" href="#"
                                 @click.prevent>
                                <i class="far fa-edit"></i>
                              </a>

                              <popover-new slot="popover" :width="332" class="tag-popover edit-tag-popover">
                                <template slot="header">
                                  Rename Branch
                                </template>

                                <div class="edit-tag-popover__para">Rename your branch here:</div>
                                <div class="control">
                                  <input v-model="reviewBranch.data" :disabled="reviewBranch.isProcessing"
                                         class="v-input input"
                                         type="text">
                                  <span v-if="reviewBranch.errors.tag"
                                        class="help is-danger has-text-weight-normal">{{
                                      reviewBranch.errors.tag[0]
                                    }}</span>
                                </div>
                                <div class="control has-text-centered">
                                  <p :class="{'edit-tag-popover__msg--hidden': !reviewBranch.isSuccess}"
                                     class="color-green edit-tag-popover__msg">Successfully renamed</p>
                                  <button
                                    :class="{'is-loading': reviewBranch.isProcessing}"
                                    :disabled="reviewBranch.data === branch.value || reviewBranch.isProcessing || !reviewBranch.data"
                                    class="button solid-btn"
                                    data-track="Reviews List - Branch Filter popup - Edit form submit"
                                    @click="renameBranch(slug)"
                                  >RENAME BRANCH</button>
                                </div>
                              </popover-new>
                            </v-popover>
                            <span class="color-blue margin-right-3">|</span>
                            <a class="blue-link" data-track="Reviews List - Branch Filter popup - Delete link" href="#"
                               @click.prevent="openDeleteTagModal('branch', slug, branch.value)">
                              <i class="far fa-trash-alt"></i>
                            </a>
                          </span>
                      </div>
                    </div>
                  </div>
                </popover-new>
              </v-popover>
            </div>
          </template>
        </accordion>

        <div v-if="!isFreeSubscription" class="export-module">
          <div class="export-module-head">Export reviews</div>
          <div>Get a CSV export of all your Hellopeter reviews</div>
          <div class="has-text-centered">
            <export-reviews :bizSlug="businessSlug" :endDate="filters.dateFilter.endDate"
                            :startDate="filters.dateFilter.startDate"/>
          </div>
        </div>
      </div>
    </div>

    <div v-if="deleteReplyModal.show" id="deleteReplyModal" class="modal is-active modal-new">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <div class="modal-card-head-title">Confirm Deletion</div>
        </header>

        <section class="modal-card-body has-text-centered">
          Delete reply? This can’t be undone.
          <div>
            <button
              class="button hollow-btn"
              data-track="Reviews List - Delete reply - Cancel button"
              @click="closeDeleteReplyModal"
            >
              CANCEL
            </button>
            <button
              class="button solid-btn"
              data-track="Reviews List - Delete reply - Submit button"
              @click="deleteReply"
            >DELETE
            </button>
          </div>
        </section>
      </div>
    </div>

    <div v-if="reportReviewModal.show" id="reportReviewModal" class="modal is-active modal-new">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <a class="modal-close-link" href="#" @click.prevent="closeReportReviewModal">
            <img src="/static/img/ads/modal_close.svg"/>
          </a>
          <div class="modal-card-head-title">Report review</div>
        </header>

        <section class="modal-card-body">
          <div class="margin-bottom-18">Why are you reporting this review?</div>

          <div class="margin-bottom-12">
            <input
              id="report1"
              v-model="reportReview.data.reason"
              class="margin-right-10"
              name="report"
              type="radio"
              value="5"
            />
            <label for="report1">The review is for a different business</label>
          </div>
          <div class="margin-bottom-12">
            <input
              id="report2"
              v-model="reportReview.data.reason"
              class="margin-right-10"
              name="report"
              type="radio"
              value="8"
            />
            <label for="report2">The review is spam or a scam</label>
          </div>
          <div class="margin-bottom-12">
            <input
              id="report3"
              v-model="reportReview.data.reason"
              class="margin-right-10"
              name="report"
              type="radio"
              value="4"
            />
            <label for="report3">The review is defamatory</label>
          </div>
          <div class="margin-bottom-12">
            <input
              id="report4"
              v-model="reportReview.data.reason"
              class="margin-right-10"
              name="report"
              type="radio"
              value="3"
            />
            <label for="report4">The review is false or contains false <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>information</label>
          </div>
          <div class="margin-bottom-15">
            <input
              id="report5"
              v-model="reportReview.data.reason"
              class="margin-right-10"
              name="report"
              type="radio"
              value="6"
            />
            <label for="report4">report5</label>
            <span v-if="reportReview.errors.review_reason"
                  class="help is-danger has-text-weight-normal">{{
                reportReview.errors.review_reason[0]
              }}</span>
          </div>

          <div class="margin-bottom-5">Please give us more information to help us investigate:</div>
          <div class="margin-bottom-10">
            <textarea v-model="reportReview.data.info" class="v-textarea textarea"></textarea>
            <span v-if="reportReview.errors.report_reason"
                  class="help is-danger has-text-weight-normal">{{
                reportReview.errors.report_reason[0]
              }}</span>
          </div>
          <button
            :disabled="false"
            class="button solid-btn is-fullwidth"
            data-track="Reviews List - Report - Submit report form"
            @click="reportAReview(reportReviewModal.review)"
          >REPORT REVIEW
          </button>
        </section>
      </div>
    </div>

    <template v-if="!isFreeSubscription">
      <div v-if="userHistoryModal.show" id="userHistoryModal" class="modal is-active modal-new">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <a class="modal-close-link" href="#" @click.prevent="closeUserHistoryModal">
              <img src="/static/img/ads/modal_close.svg"/>
            </a>
            <div class="modal-card-head-title">User history</div>
          </header>

          <section class="modal-card-body">
            <div class="level">
              <div class="level-left">
                Written {{ userhistory[`user-${userHistoryModal.userId}`].totalReviewsCount }} Reviews
              </div>
              <div class="level-right">
                Active since: {{ userhistory[`user-${userHistoryModal.userId}`].activeDatetime }}
              </div>
            </div>
            <accordion v-for="(org, key) in userhistory[`user-${userHistoryModal.userId}`].orgs" :key="key"
                       :open="false" :title="`${org.name} ${org.count} Reviews`">
              <div v-for="review in org.reviews" class="review-card">
                <div class="is-flex">
                  <div>
                    <div class="has-text-weight-bold">{{ review.title }}</div>
                    <rating
                      :stars="review.rating"
                      class="star-rating-review"
                    ></rating>
                  </div>
                  <div class="review-meta">
                    <div class="has-text-weight-bold">Written at: {{ review.datetime }}</div>
                  </div>
                </div>
                <div class="line-height-20 margin-top-20">{{ review.body }}</div>
              </div>
            </accordion>
          </section>
        </div>
      </div>

      <div v-if="deleteTagModal.show" id="deleteTagModal" class="modal is-active modal-new">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <div class="modal-card-head-title">Confirm Deletion</div>
          </header>

          <section class="modal-card-body">
            <div class="has-text-centered">
              Delete
              <template v-if="deleteTagModal.entity === 'tag'">Tag</template>
              <template v-else>Branch</template>
              <strong>{{ deleteTagModal.value }}</strong>?
            </div>
            <div class="margin-top-15 margin-bottom-20">
              Deleting this
              <template v-if="deleteTagModal.entity === 'tag'">tag</template>
              <template v-else>branch</template>
              will permanently remove it from everywhere
              <template v-if="deleteTagModal.entity === 'tag'">tags</template>
              <template v-else>branches</template>
              are used.
            </div>

            Deleted
            <template v-if="deleteTagModal.entity === 'tag'">tags</template>
            <template v-else>branches</template>
            :
            <ul>
              <li>Will not appear in filters.</li>
              <li>Cannot be applied to reviews.</li>
              <li>Will be removed from all reviews to which it was previously applied.</li>
            </ul>

            <div>
              <button
                class="button hollow-btn"
                data-track="Reviews List - Delete tag/branch - Cancel button"
                @click="closeDeleteTagModal"
              >
                CANCEL
              </button>
              <button
                :class="{'is-loading': deleteTagModal.isProcessing}"
                :disabled="deleteTagModal.isProcessing"
                class="button solid-btn"
                data-track="Reviews List - Delete tag/branch - Submit button"
                @click="deleteEntity(deleteTagModal.entity)"
              >DELETE
              </button>
            </div>
          </section>
        </div>
      </div>
    </template>
    <GMBModal
      v-if="showFacebookPageSelect"
      :facebook-pages="multiple_pages"
      :show=showFacebookPageSelect
      page='facebookPageSelect'
      @closeModal="toggleGMBModal=false"
      @updateFinished="completeFacebookPageSelectSetup()"
    ></GMBModal>
  </div>
</template>

<script>
/* global flash, dataLayer, modal */
/* eslint no-undef: "error" */
// https://www.npmjs.com/package/v-tooltip
import { gmb, misc } from '@/mixins'
import {
  Accordion,
  AlertMessage,
  BuyCredits,
  ChannelManage,
  ColoredCheckbox,
  CustomDropdown,
  CustomDropdownForm,
  DateSelectFilter,
  Paginator,
  PopoverNew,
  Rating,
  ReviewAttachments,
  SavedRepliesPopup,
  SearchField,
  Wysiwyg,
  ExportReviews
} from '@/components'
import { TooltipNew } from '@/widgets'
import Avatar from 'vue-avatar'
import axios from 'axios'
import moment from 'moment'
import GMBModal from './../../components/GMBModal.vue'

export default {
  name: 'BusinessReviewsListNew',
  components: {
    SearchField,
    DateSelectFilter,
    ColoredCheckbox,
    Accordion,
    Rating,
    CustomDropdown,
    TooltipNew,
    Avatar,
    Wysiwyg,
    BuyCredits,
    PopoverNew,
    AlertMessage,
    CustomDropdownForm,
    SavedRepliesPopup,
    ChannelManage,
    ReviewAttachments,
    Paginator,
    GMBModal,
    ExportReviews
  },
  mixins: [misc, gmb],
  metaInfo: {
    title: 'Business Portal | Hellopeter - Reviews Listing'
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Reviews Listing'
    })

    // break up multiple facebook page selection from FB redirect if applicable
    if (this.$route.query.hasOwnProperty('multiple_pages') && this.$route.query.hasOwnProperty('pages[0][pageID]')) {
      let counter = 0
      let pageId = ''
      let pageName = ''
      let pageToken = this.$route.query.token

      for (let key of Object.keys(this.$route.query)) {
        if (key.startsWith('pages')) {
          counter++
          if (key.endsWith('pageID]')) {
            pageId = this.$route.query[key]
          } else {
            pageName = this.$route.query[key]
          }

          if (counter % 2 === 0) {
            this.multiple_pages.push({
              pageId: pageId,
              pageName: pageName,
              pageToken: pageToken
            })
            pageId = ''
            pageName = ''
          }
        }
      }
      // flash('You cannot select more than one Facebook page. Please contact our admin for assistance', 'is-danger')
    } else if (this.$route.query.hasOwnProperty('flash_msg') && this.$route.query.hasOwnProperty('flash_success')) {
      const flashType = (typeof this.$route.query.flash_success !== 'undefined' && this.$route.query.flash_success === '1') ? 'is-success' : 'is-danger'
      flash(this.$route.query.flash_msg, flashType)
    }
  },
  data () {
    return {
      toggleGMBModal: false,
      multiple_pages: [],
      filters: {
        permalink: '',
        string: '',
        dateFilter: {
          label: 'last_6_months',
          endDate: null,
          startDate: null,
          styleProp: '',
          props: [{
            name: 'date',
            label: 'Date',
            showApplyBtn: true,
            dataTrack: 'data-track="Reviews List - Date filter change"',
            default: { type: 'months', value: 6, selected: 'All time' }, // moment.js placeholder in type
            disabled: [],
            elements: ['Last 7 days', 'Previous month', 'Last 6 months', 'Last 12 months', 'All time', 'Custom']
          }],
          reviews_start_date: '',
          key: 'desktop-filter-'
        },
        status: [],
        rating: [],
        nps: [],
        channel: [],
        source: [],
        tags: [],
        branches: [],
        sortBy: 'date_desc'
      },
      sortDdOpts: [
        {
          'label': 'Date (latest)',
          'value': 'date_desc',
          'selected': true,
          'attr': { 'data-track': 'Reviews List - Sort dropdown - Date (latest)' }
        },
        {
          'label': 'Date (oldest)',
          'value': 'date_asc',
          'attr': { 'data-track': 'Reviews List - Sort dropdown - Date (oldest)' }
        },
        /* {
          'label': 'With Images',
          'value': 'fb_feed',
          'attr': {'data-track': 'Reviews List - Sort dropdown - With Images'}
        },
        {
          'label': 'With Notes',
          'value': 'inst_post',
          'attr': {'data-track': 'Reviews List - Sort dropdown - With Notes'}
        }, */
        {
          'label': 'Star rating (high to low)',
          'value': 'rating_desc',
          'attr': { 'data-track': 'Reviews List - Sort dropdown - Star rating (high to low)' }
        },
        {
          'label': 'Star rating (low to high)',
          'value': 'rating_asc',
          'attr': { 'data-track': 'Reviews List - Sort dropdown - Star rating (low to high)' }
        }
      ],
      filterDd: {
        options: [
          {
            'type': 'group',
            'label': 'Status'
          },
          {
            'label': 'Unreplied Reviews',
            'value': 'unreplied',
            'type': 'checkbox',
            'group': 'status',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - Status Filters - Unreplied Reviews'
            }
          },
          {
            'label': 'Unread',
            'value': 'unread',
            'type': 'checkbox',
            'group': 'status',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - Status Filters - Unread'
            }
          },
          {
            'label': 'Unreplied Comments',
            'value': 'unreplied_comment',
            'type': 'checkbox',
            'group': 'status',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - Status Filters - Unreplied Comments'
            }
          },
          {
            'type': 'group',
            'label': 'Star rating'
          },
          {
            'component': true,
            'label': [
              '<span>5 Star</span>',
              {
                'component': 'rating',
                'props': {
                  'class': 'font-size-5 star-rating-filter',
                  'stars': 5
                }
              },
              '<span class="star-rating-count">0 Reviews</span>'
            ],
            'value': '5',
            'type': 'checkbox',
            'group': 'starRating',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - Status rating Filters'
            }
          },
          {
            'component': true,
            'label': [
              '<span>4 Star</span>',
              {
                'component': 'rating',
                'props': {
                  'class': 'font-size-5 star-rating-filter',
                  'stars': 4
                }
              },
              '<span class="star-rating-count">0 Reviews</span>'
            ],
            'value': '4',
            'type': 'checkbox',
            'group': 'starRating',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - Status rating Filters'
            }
          },
          {
            'component': true,
            'label': [
              '<span>3 Star</span>',
              {
                'component': 'rating',
                'props': {
                  'class': 'font-size-5 star-rating-filter',
                  'stars': 3
                }
              },
              '<span class="star-rating-count">0 Reviews</span>'
            ],
            'value': '3',
            'type': 'checkbox',
            'group': 'starRating',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - Status rating Filters'
            }
          },
          {
            'component': true,
            'label': [
              '<span>2 Star</span>',
              {
                'component': 'rating',
                'props': {
                  'class': 'font-size-5 star-rating-filter',
                  'stars': 2
                }
              },
              '<span class="star-rating-count">0 Reviews</span>'
            ],
            'value': '2',
            'type': 'checkbox',
            'group': 'starRating',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - Status rating Filters'
            }
          },
          {
            'component': true,
            'label': [
              '<span>1 Star</span>',
              {
                'component': 'rating',
                'props': {
                  'class': 'font-size-5 star-rating-filter',
                  'stars': 1
                }
              },
              '<span class="star-rating-count">0 Reviews</span>'
            ],
            'value': '1',
            'type': 'checkbox',
            'group': 'starRating',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - Status rating Filters'
            }
          },
          {
            'type': 'group',
            'label': 'NPS Responses'
          },
          {
            'label': '<img src="/static/img/reviews/promoters_small.svg" class="margin-right-7 valign-bottom"/> Promotors (9-10) <span class="nps-count">0 Responses</span>',
            'value': 'promotors',
            'type': 'checkbox',
            'group': 'nps',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - NPS Filters - Promotors'
            }
          },
          {
            'label': '<img src="/static/img/reviews/passives_small.svg" class="margin-right-7 valign-bottom"/> <span class="margin-right-20">Passives (7-8)</span> <span class="nps-count">0 Responses</span>',
            'value': 'passives',
            'type': 'checkbox',
            'group': 'nps',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - NPS Filters - Passives'
            }
          },
          {
            'label': '<img src="/static/img/reviews/detractors_small.svg" class="margin-right-7 valign-bottom"/> <span class="margin-right-8">Detractors (0-6)</span> <span class="nps-count">0 Responses</span>',
            'value': 'detractors',
            'type': 'checkbox',
            'group': 'nps',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - NPS Filters - Detractors'
            }
          },
          {
            'type': 'group',
            'label': 'Channel'
          },
          {
            'label': '<img src="/static/img/logo/favicon-16x16.png" class="valign-bottom"/> &nbsp;Hellopeter',
            'value': 'HELLOPETER',
            'type': 'checkbox',
            'group': 'channel',
            'checked': false,
            'props': {
              'data-track': 'Reviews List - Channel Filters - Hellopeter'
            }
          }
        ],
        key: 'touch-filter-'
      },

      reviewsList: {
        isLoading: true,
        items: [],
        recordsCount: 0,
        paging: {
          current_page: 1,
          prev_page_url: false,
          next_page_url: false,
          last_page: 1,
          per_page: 10
        }
      },
      reviewDetails: {},
      sourcesList: {},
      sourcesListKey: 'source-list-',
      tagsList: {},
      branchesList: {},
      ratings: {
        'star-5': {
          rating: 5,
          count: 0
        },
        'star-4': {
          rating: 4,
          count: 0
        },
        'star-3': {
          rating: 3,
          count: 0
        },
        'star-2': {
          rating: 2,
          count: 0
        },
        'star-1': {
          rating: 1,
          count: 0
        }
      },
      nps: {
        'promotors': 0,
        'passives': 0,
        'detractors': 0
      },
      userhistory: {},
      slug: window.localStorage.getItem('org_slug'),
      bizName: window.localStorage.getItem('org_name'),
      globalKey: 0,
      filterByStringTimeoutId: 0,
      isReviewDetailPage: false,

      reportReview: {
        popoverDisable: false,
        isProcessing: false,
        errors: {},
        data: {
          reason: '',
          info: ''
        }
      },
      reviewNote: {
        isProcessing: false,
        data: '',
        popoverDisable: false
      },
      reviewTags: {
        isProcessing: false,
        data: '',
        tagToEdit: '',
        popoverDisable: false,
        errors: {},
        isSuccess: false
      },
      reviewBranch: {
        isProcessing: false,
        data: '',
        branchToEdit: '',
        popoverDisable: false,
        errors: {},
        isSuccess: false
      },
      quickReply: {
        isProcessing: false,
        data: {
          reply: '',
          replyType: 1 // 1 = public, 2 = private
        },
        masking: {
          email: '',
          phoneNumber: ''
        },
        openedPopoverIndex: false
      },
      newReply: {
        key: 0
      },
      editReply: {
        key: 0
      },

      userHistoryModal: {
        show: false,
        userId: 0
      },
      deleteReplyModal: {
        show: false,
        reviewPermalink: '',
        replyId: ''
      },
      deleteTagModal: {
        show: false,
        entity: '',
        value: '',
        slug: '',
        isProcessing: false
      },
      reportReviewModal: {
        show: false,
        review: {}
      }
    }
  },
  created () {
    this.loadReviewFilters()

    if ('permalink' in this.$route.params) {
      this.isReviewDetailPage = true
      this.filters.permalink = this.$route.params.permalink
      this.reviewsList.paging.per_page = 1
    } else {
      if (!this.isDesktop) {
        this.checkGMBSetup()
          .then(() => {
            if (this.isGoogleConnected) {
              this.filterDd.options.push({
                'label': '<img src="/static/img/social/google/google_channel_hq.png" class="w-15 valign-bottom"/> &nbsp;Google',
                'value': 'GOOGLE',
                'type': 'checkbox',
                'group': 'channel',
                'checked': false,
                'props': {
                  'data-track': 'Reviews List - Channel Filters - Google'
                }
              })
            }
          })
      }

      this.checkFacebookReviewsSetup()
        .then(() => {
          if (this.isFacebookReviewsConnected) {
            this.filterDd.options.push({
              'label': '<img src="/static/img/social/fb/fb.png" class="w-15 valign-bottom"/> &nbsp;Facebook',
              'value': 'FACEBOOK',
              'type': 'checkbox',
              'group': 'channel',
              'checked': false,
              'props': {
                'data-track': 'Reviews List - Channel Filters - Facebook'
              }
            })
          }
        })

      const reviewDeleted = window.localStorage.getItem('reviewDeleted')
      if (typeof reviewDeleted !== 'undefined' && reviewDeleted) {
        flash('Review has been deleted.', 'is-danger')
        window.localStorage.removeItem('reviewDeleted')
      }

      let firstActiveReviewDate = window.localStorage.firstActiveReviewDate
      if (typeof firstActiveReviewDate === 'undefined') {
        window.events.$on('firstActiveReviewDateLoaded', data => {
          firstActiveReviewDate = window.localStorage.firstActiveReviewDate
          if (!firstActiveReviewDate) {
            firstActiveReviewDate = moment().format('YYYY-MM-DD')
          }
          this.filters.dateFilter.reviews_start_date = firstActiveReviewDate
        })
      } else {
        if (!firstActiveReviewDate) {
          firstActiveReviewDate = moment().format('YYYY-MM-DD')
        }
        this.filters.dateFilter.reviews_start_date = firstActiveReviewDate
      }

      if ('status' in this.$route.query) {
        this.statusFilterToggle(true, this.$route.query.status)

        if (!this.isDesktop) {
          this.filterDdCbxToggle('status')
        }
      }

      window.events.$on('custom-dd-form-changed', data => {
        if (data.group === 'reviewsListFilterFormDd') {
          if (data.data.group === 'status') {
            this.statusFilterToggle(data.isChecked, data.data.value)
          } else if (data.data.group === 'starRating') {
            this.ratingFilterToggle(data.isChecked, data.data.value)
          } else if (data.data.group === 'channel') {
            this.channelFilterToggle(data.isChecked, data.data.value)
          } else if (data.data.group === 'nps') {
            this.npsFilterToggle(data.isChecked, data.data.value)
          }
          this.filterDdCbxToggle()
        }
      })
      window.events.$on('custom-dd-changed', (data) => {
        if (data.group === 'reviewsListSortDd' && data.changedByHuman) {
          this.filters.sortBy = data.value
        }
      })
    }

    window.events.$on('switchReplyType', data => {
      this.switchReplyType(data)
    })
    window.events.$on('keepMasked', data => {
      this.postReply(data.payload.node)
    })
  },
  destroyed () {
    if (!this.isReviewDetailPage) {
      window.events.$off('custom-dd-form-changed')
      window.events.$off('custom-dd-changed')
    }
    window.events.$off('switchReplyType')
    window.events.$off('keepMasked')
    window.events.$off('firstActiveReviewDateLoaded')
  },
  methods: {
    populateBranchEdit (branch) {
      this.reviewBranch.branchToEdit = branch
      this.reviewBranch.data = branch
    },
    renameBranch (branchSlug) {
      this.reviewBranch.isProcessing = true

      axios.patch(`/business/${this.businessSlug}/branches/${branchSlug}`, {
        branch: this.reviewBranch.data
      })
        .then(({ data }) => {
          this.reviewBranch.isProcessing = false
          this.reviewBranch.isSuccess = true
          this.reviewBranch.popoverDisable = true

          this.reviewsList.items.forEach(review => {
            if (branchSlug in review.branch) {
              const reviewBranch = review.branch[branchSlug]
              this.$delete(review.branch, branchSlug)
              review.branch[data.data.newSlug] = {
                'value': data.data.newBranch,
                'isCustom': 0,
                'isLinkedFromQr': reviewBranch.isLinkedFromQr
              }
            }
          })

          const branchSlugs = Object.keys(this.branchesList)
          const branchIsAt = branchSlugs.indexOf(branchSlug)
          const keyValues = Object.entries(this.branchesList)
          keyValues.splice(branchIsAt, 1, [data.data.newSlug, {
            'value': data.data.newBranch,
            'isCustom': 0
          }])
          this.branchesList = Object.fromEntries(keyValues)
          const isUnselected = this.unselectBranch(branchSlug)
          if (isUnselected) {
            this.branchFilterToggle(true, data.data.newSlug)
          }
        })
        .catch(errors => {
          this.reviewBranch.isProcessing = false
          if (errors.response.status === 422) {
            this.reviewBranch.errors = errors.response.data
          } else {
            flash('There was an error renaming the branch. Please try again later!', 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to rename the branch on Review List',
                'displayedMessage': 'There was an error renaming the branch. Please try again later!'
              }
            })
          }
        })
    },
    resetAddBranchForm () {
      this.$nextTick(() => { // Using nextTick to fix issue: Popup not closing after linking branch
        this.reviewBranch.branchToEdit = ''
        this.reviewBranch.data = ''
        this.reviewBranch.isSuccess = false
        this.reviewBranch.popoverDisable = false
        Object.assign(this.reviewBranch.errors, { branch: '' })
      })
    },
    createAndLinkBranch (review) {
      this.linkBranch(this.reviewBranch.data, review)
    },
    linkBranch (branch, review) {
      this.reviewBranch.isProcessing = true

      axios.post(`/business/${this.businessSlug}/reviews/${review.permalink}/branch`, {
        branch: branch,
        channel: review.channel
      })
        .then(({ data }) => {
          this.reviewBranch.isProcessing = false
          this.reviewBranch.popoverDisable = true

          review.branch[data.data.slug] = {
            'value': data.data.branch,
            'isCustom': data.data.isCustom,
            'isLinkedFromQr': 0
          }
          this.branchesList[data.data.slug] = {
            'value': data.data.branch,
            'isCustom': data.data.isCustom
          }
        })
        .catch(errors => {
          this.reviewBranch.isProcessing = false
          if (errors.response.status === 422) {
            this.reviewBranch.errors = errors.response.data
          } else {
            flash('There was an error adding the branch to the review. Please try again later!', 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to add the review branch on Review List',
                'displayedMessage': 'There was an error adding the branch to the review. Please try again later!'
              }
            })
          }
        })
    },
    unlinkBranch (branchSlug, review) {
      axios.delete(`/business/${this.businessSlug}/reviews/${review.permalink}/branch/${branchSlug}`, {
        data: {
          channel: review.channel
        }
      })
        .then(({ data }) => {
          this.$delete(review.branch, branchSlug)
        })
        .catch(errors => {
          flash('There was an error unlinking the branch from the review. Please try again later!', 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to unlink the review branch on Review List',
              'displayedMessage': 'There was an error unlinking the branch from the review. Please try again later!'
            }
          })
        })
    },

    openDeleteTagModal (entity, slug, value) {
      this.deleteTagModal.show = true
      this.deleteTagModal.entity = entity
      this.deleteTagModal.slug = slug
      this.deleteTagModal.value = value
    },
    closeDeleteTagModal () {
      this.deleteTagModal.show = false
    },
    deleteEntity (entity) {
      this.deleteTagModal.isProcessing = true

      if (entity === 'tag') {
        axios.delete(`/business/${this.businessSlug}/tags/${this.deleteTagModal.slug}`)
          .then(({ data }) => {
            this.deleteTagModal.isProcessing = false

            this.reviewsList.items.forEach(review => {
              this.$delete(review.tags, this.deleteTagModal.slug)
            })
            this.$delete(this.tagsList, this.deleteTagModal.slug)
            this.tagFilterToggle(false, this.deleteTagModal.slug)

            this.closeDeleteTagModal()
          })
          .catch(errors => {
            this.deleteTagModal.isProcessing = false

            flash('There was an error deleting the tag. Please try again later!', 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to delete the tag on Review List',
                'displayedMessage': 'There was an error deleting the tag. Please try again later!'
              }
            })
          })
      } else if (entity === 'branch') {
        axios.delete(`/business/${this.businessSlug}/branches/${this.deleteTagModal.slug}`)
          .then(({ data }) => {
            this.deleteTagModal.isProcessing = false

            this.reviewsList.items.forEach(review => {
              this.$delete(review.branch, this.deleteTagModal.slug)
            })
            this.$delete(this.branchesList, this.deleteTagModal.slug)
            this.branchFilterToggle(false, this.deleteTagModal.slug)

            this.closeDeleteTagModal()
          })
          .catch(errors => {
            this.deleteTagModal.isProcessing = false

            flash('There was an error deleting the branch. Please try again later!', 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to delete the branch on Review List',
                'displayedMessage': 'There was an error deleting the branch. Please try again later!'
              }
            })
          })
      }
    },
    populateTagEdit (tag) {
      this.reviewTags.tagToEdit = tag
      this.reviewTags.data = tag
    },
    renameTag (tagSlug) {
      this.reviewTags.isProcessing = true

      axios.patch(`/business/${this.businessSlug}/tags/${tagSlug}`, {
        tag: this.reviewTags.data
      })
        .then(({ data }) => {
          this.reviewTags.isProcessing = false
          this.reviewTags.isSuccess = true
          this.reviewTags.popoverDisable = true

          this.reviewsList.items.forEach(review => {
            if (tagSlug in review.tags) {
              this.$delete(review.tags, tagSlug)
              review.tags[data.data.newSlug] = data.data.newTag
            }
          })

          const tagSlugs = Object.keys(this.tagsList)
          const tagIsAt = tagSlugs.indexOf(tagSlug)
          const keyValues = Object.entries(this.tagsList)
          keyValues.splice(tagIsAt, 1, [data.data.newSlug, data.data.newTag])
          this.tagsList = Object.fromEntries(keyValues)
          const isUnselected = this.unselectTag(tagSlug)
          if (isUnselected) {
            this.tagFilterToggle(true, data.data.newSlug)
          }
        })
        .catch(errors => {
          this.reviewTags.isProcessing = false
          if (errors.response.status === 422) {
            this.reviewTags.errors = errors.response.data
          } else {
            flash('There was an error renaming the tag. Please try again later!', 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to rename the tag on Review List',
                'displayedMessage': 'There was an error renaming the tag. Please try again later!'
              }
            })
          }
        })
    },
    resetAddTagForm () {
      this.reviewTags.tagToEdit = ''
      this.reviewTags.data = ''
      this.reviewTags.isSuccess = false
      this.reviewTags.popoverDisable = false
      Object.assign(this.reviewTags.errors, { tag: '' })
    },
    createAndLinkTag (review) {
      this.linkTag(this.reviewTags.data, review)
    },
    linkTag (tag, review) {
      this.reviewTags.isProcessing = true

      axios.post(`/business/${this.businessSlug}/reviews/${review.permalink}/tags`, {
        tag: tag,
        channel: review.channel
      })
        .then(({ data }) => {
          this.reviewTags.isProcessing = false
          this.reviewTags.popoverDisable = true

          review.tags[data.data.slug] = data.data.tag
          this.tagsList[data.data.slug] = data.data.tag
        })
        .catch(errors => {
          this.reviewTags.isProcessing = false
          if (errors.response.status === 422) {
            this.reviewTags.errors = errors.response.data
          } else {
            flash('There was an error adding the tag to the review. Please try again later!', 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to add the review tag on Review List',
                'displayedMessage': 'There was an error adding the tag to the review. Please try again later!'
              }
            })
          }
        })
    },
    unlinkTag (tagSlug, review) {
      axios.delete(`/business/${this.businessSlug}/reviews/${review.permalink}/tags/${tagSlug}`, {
        data: {
          channel: review.channel
        }
      })
        .then(({ data }) => {
          this.$delete(review.tags, tagSlug)
        })
        .catch(errors => {
          flash('There was an error unlinking the tag from the review. Please try again later!', 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to unlink the review tag on Review List',
              'displayedMessage': 'There was an error unlinking the tag from the review. Please try again later!'
            }
          })
        })
    },

    resetAddNoteForm () {
      this.reviewNote.data = ''
      this.reviewNote.popoverDisable = false
    },
    addNote (permalink) {
      this.reviewNote.isProcessing = true
      axios.post(`/business/${this.businessSlug}/reviews/${permalink}/notes`, {
        message: this.reviewNote.data
      })
        .then(({ data }) => {
          this.reviewNote.isProcessing = false
          this.reviewNote.popoverDisable = true

          this.appendNoteToReview(permalink, {
            author: data.author.name,
            datetime: this.prettifyDatetime(data.created_at),
            body: this.reviewNote.data
          })
        })
        .catch(() => {
          this.reviewNote.isProcessing = false
          flash('There was an error adding the note to the review. Please try again later!', 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to add the review note on Review List',
              'displayedMessage': 'There was an error adding the note to the review. Please try again later!'
            }
          })
        })
    },
    appendNoteToReview (reviewPermalink, noteData) {
      if (reviewPermalink in this.reviewDetails) {
        this.reviewDetails[reviewPermalink].teamNotes.push({
          author: noteData.author,
          datetime: noteData.datetime,
          body: noteData.body
        })
      }
    },

    resetReportForm () {
      Object.assign(this.reportReview.data, { info: '', reason: '' })
      Object.assign(this.reportReview.errors, { report_reason: '', review_reason: '' })
      this.reportReview.popoverDisable = false
    },
    reportAReview (review) {
      this.reportReview.isProcessing = true

      axios.post(`/report-review/${review.permalink}`, {
        businessSlug: this.businessSlug,
        report_reason: this.reportReview.data.info,
        review_reason: this.reportReview.data.reason
      })
        .then(({ data }) => {
          this.reportReview.isProcessing = false
          this.reportReview.popoverDisable = true
          review.isReported = true
        })
        .catch((errors) => {
          this.reportReview.isProcessing = false
          this.reportReview.errors = errors.response.data
        })
    },
    openReportReviewModal (review) {
      this.reportReviewModal.review = review
      this.reportReviewModal.show = true
    },
    closeReportReviewModal () {
      this.reportReviewModal.show = false
      this.resetReportForm()
    },

    openUserHistoryModal (rev) {
      // If reviewer history has not fetched already
      if (!(`user-${rev.reviewerId}` in this.userhistory)) {
        axios.get(`/business/${this.businessSlug}/reviews/${rev.permalink}/author/reviews`)
          .then(({ data }) => {
            delete data['reviewIds']

            const orgs = {}
            let totalReviewsCount = 0
            for (const reviewIdx in data) {
              const review = data[reviewIdx]
              if (review.business) {
                totalReviewsCount++

                const reviewObj = {
                  title: review.review_title,
                  datetime: this.prettifyDatetime(review.created_at),
                  rating: review.review_rating,
                  body: review.review_content
                }

                if (`org-${review.business.id}` in orgs) {
                  ++orgs[`org-${review.business.id}`].count
                  orgs[`org-${review.business.id}`].reviews.push(reviewObj)
                } else {
                  orgs[`org-${review.business.id}`] = {
                    name: review.business.name,
                    count: 1,
                    reviews: [reviewObj]
                  }
                }
              }
            }
            this.userhistory[`user-${rev.reviewerId}`] = {
              totalReviewsCount,
              activeDatetime: this.prettifyDate(this.reviewDetails[rev.permalink].author.createdAt),
              orgs
            }
            this.userHistoryModal.show = true
            this.userHistoryModal.userId = rev.reviewerId
          })
          .catch(error => {
            console.log(error)
            this.displayErrMsg(error, 'Failed to fetch the reviewer history on Review List', `There was an error fetching the reviewer history. Please try again later!`)
          })
      } else {
        this.userHistoryModal.show = true
        this.userHistoryModal.userId = rev.reviewerId
      }
    },
    closeUserHistoryModal () {
      this.userHistoryModal.show = false
    },

    resetReviewsList () {
      this.reviewsList.items = []
      this.reviewsList.recordsCount = 0
    },
    loadReviewsList (page) {
      this.reviewsList.isLoading = true

      const recordStartIdx = (page * this.reviewsList.paging.per_page) - this.reviewsList.paging.per_page
      const returnObj = this.loadReviewsListApi(recordStartIdx)
      returnObj.prom.then(() => {
        this.reviewsList.items = returnObj.reviewsArr
        if (this.isReviewDetailPage && this.reviewsList.items.length) {
          this.showReviewDetails(this.reviewsList.items[0])
        }

        const lastPage = Math.ceil(this.reviewsList.recordsCount / this.reviewsList.paging.per_page)
        this.reviewsList.paging = {
          current_page: page,
          prev_page_url: page !== 1,
          next_page_url: page !== lastPage,
          last_page: lastPage,
          per_page: this.reviewsList.paging.per_page
        }

        this.reviewsList.isLoading = false

        window.scrollTo(0, 0)
      })
    },
    loadReviewsListApi (recordStartAt) {
      const sort = {
        by: this.filters.sortBy,
        order: 'desc'
      }
      if (this.filters.sortBy === 'date_desc') {
        sort.by = 'created_at'
      } else if (this.filters.sortBy === 'date_asc') {
        sort.by = 'created_at'
        sort.order = 'asc'
      } else if (this.filters.sortBy === 'rating_desc') {
        sort.by = 'rating'
      } else if (this.filters.sortBy === 'rating_asc') {
        sort.by = 'rating'
        sort.order = 'asc'
      }
      const prom = axios.get(`/business/${this.businessSlug}/reviews`, {
        params: {
          filters: {
            permalink: this.filters.permalink,
            string: this.filters.string,
            date: {
              start: this.filters.dateFilter.startDate,
              end: this.filters.dateFilter.endDate
            },
            status: this.filters.status,
            rating: this.filters.rating,
            nps: this.filters.nps,
            channel: this.filters.channel,
            source: this.filters.source,
            tags: this.filters.tags,
            branches: this.filters.branches
          },
          sort,
          paging: {
            start: recordStartAt,
            count: this.reviewsList.paging.per_page
          }
        }
      })
      const reviewsArr = []
      prom.then(({ data }) => {
        data.data.reviews.forEach(review => {
          if (review._source.status === 'DELETED') {
            window.localStorage.setItem('reviewDeleted', true)
            window.location.href = '/reviews'
          } else {
            let reviewId = review._id
            if (!this.isHpPlatformReview(review._source)) {
              reviewId = (review._source.permalink.split('-'))[1]
            }

            let reviewimages = []
            if ('uploaded_images' in review._source && review._source.uploaded_images !== null) {
              review._source.uploaded_images.forEach(image => {
                const lio = image.lastIndexOf('/')
                reviewimages.push({
                  attachment_folder_url: image.substring(0, lio + 1),
                  attachment_name: image.substring(image.lastIndexOf('/') + 1)
                })
              })
            }

            let reviewReplies = []
            if ('messages' in review._source && review._source.messages !== null) {
              reviewReplies = review._source.messages
            }

            let isReviewStamped = false
            if (!this.isHpPlatformReview(review._source) || ('review_stamp' in review._source && review._source.review_stamp !== null) || ('Stamp' in review._source && review._source.Stamp !== null)) {
              isReviewStamped = true
            }

            let reviewTags = {}
            if ('tags' in review._source && review._source.tags !== null) {
              review._source.tags.forEach(obj => {
                reviewTags[obj.Slug] = obj.Name
              })
            }

            let reviewBranch = {}
            if ('branches' in review._source && review._source.branches !== null) {
              reviewBranch[review._source.branches.slug] = {
                isLinkedFromQr: review._source.branches.isLinkedFromQr,
                isCustom: review._source.branches.isCustom,
                value: review._source.branches.value
              }
            }

            const obj = {
              id: reviewId,
              url: `${this.cfUrl}/${this.businessSlug}/reviews/${review._source.permalink}`,
              permalink: review._source.permalink,
              title: review._source.review_title,
              rating: review._source.rating,
              datetime: this.prettifyDatetime(review._source.created_at),
              nps: (!('nps_score' in review._source) || review._source.nps_score === null) ? 'pending' : `${review._source.nps_score} ${this.calcNpsCat(review._source.nps_score)}`,
              channel: review._source.channel,
              body: review._source.review_body,
              source: (review._source.source) ? review._source.source : 'WEBSITE',
              images: reviewimages,
              tags: reviewTags,
              branch: reviewBranch,
              isReported: 'reported' in review._source && review._source.reported,
              isRead: review._source.read,
              isReplied: review._source.replied,
              repliedToComments: ('replied_comments' in review._source) ? review._source.replied_comments : true, // If "replied_comments" is false then it means a review has customer reply but biz has not responded to that reply yet

              loadingDetails: false,
              showDetails: false,
              reviewerId: review._source.user_id,
              reviewerName: review._source.authorDisplayName,
              checkingCanReply: false,
              canReply: 'no',
              replies: reviewReplies,
              isStamped: isReviewStamped
            }

            reviewsArr.push(obj)
          }
        })

        if (!this.isReviewDetailPage) {
          this.reviewsList.recordsCount = data.data.count.all

          if (this.isDesktop) {
            for (let ratingKey in this.ratings) {
              let count = 0
              if (ratingKey in data.data.count.rating) {
                count = data.data.count.rating[ratingKey]
              }
              this.ratings[ratingKey].count = count
            }

            for (let key in this.nps) {
              let count = 0
              if (key in data.data.count.nps) {
                count = data.data.count.nps[key]
              }

              this.nps[key] = count
            }
          } else {
            this.filterDd.options.forEach(opt => {
              if (opt.type === 'checkbox') {
                if (opt.group === 'starRating') {
                  let count = 0
                  if (`star-${opt.value}` in data.data.count.rating) {
                    count = data.data.count.rating[`star-${opt.value}`]
                  }
                  opt.label[2] = `<span class="star-rating-count">${count} Reviews</span>`
                } else if (opt.group === 'nps') {
                  let count = 0
                  if (opt.value in data.data.count.nps) {
                    count = data.data.count.nps[opt.value]
                  }
                  opt.label = opt.label.replace(/<span class="nps-count">[0-9]+/g, `<span class="nps-count">${count}`)
                }
              }
            })
            this.globalKey++
            this.filterDd.key = `touch-filter-${this.globalKey}`
          }
        }
      })
      return { prom, reviewsArr }
    },
    loadReviewFilters () {
      axios.get(`/business/${this.businessSlug}/reviews/filters`)
        .then(({ data }) => {
          // Sources
          data.data.sources.forEach(source => {
            if (source.key && source.key in this.allSources) {
              this.sourcesList[source.key] = this.allSources[source.key]['label']
            }
          })
          this.globalKey++
          this.sourcesListKey = `source-list-${this.globalKey}`

          // Tags
          data.data.tags.forEach(tag => {
            this.$set(this.tagsList, tag.tag_slug, tag.tag)
          })

          // Branches
          data.data.branches.forEach(branch => {
            this.$set(this.branchesList, branch.slug, { value: branch.name, isCustom: branch.is_custom_branch })
          })
        })
        .catch(error => {
          this.displayErrMsg(error, 'Failed to fetch the review filters on Review List', `There was an error fetching the review filters. Please try again later!`)
        })
    },
    showReviewDetails (review) {
      review.loadingDetails = true
      this.refreshCanBizReply(review)
      this.newReply[review.permalink] = {}
      this.resetNewReplyForm(this.newReply[review.permalink], review)

      // If review details have not fetched already
      if (!(review.permalink in this.reviewDetails)) {
        let stampReview = new Promise(resolve => {
          if (this.isHpPlatformReview(review) && !review.isStamped) { // HP review is not stamped
            axios.post(`/business/${this.businessSlug}/reviews/${review.permalink}/stamp`)
              .then(({ data }) => {
                review.isStamped = data.data.canSeeSensitive

                if (data.data.canSeeSensitive) {
                  review.body = data.data.sensitiveData.body
                  review.title = data.data.sensitiveData.title
                  window.events.$emit('loadHeaderStats')
                }

                resolve([false, data.data.sensitiveData])
              })
          } else { // Google/FB review or review is stamped already
            resolve([true])
          }
        })

        stampReview.then(async ([wasStampedAlready, sensitiveData]) => {
          let reviewerDetailsAxios
          let notesAxios

          if (this.isHpPlatformReview(review)) {
            if (wasStampedAlready) { // Review was already stamped
              reviewerDetailsAxios = axios(`/business/${this.businessSlug}/reviews/${review.permalink}/author`) // Fetch reviewer details
            }
          }
          if (!review.isRead) {
            if (this.isHpPlatformReview(review) && wasStampedAlready) {
              axios.post(`/business/${this.businessSlug}/reviews/${review.permalink}/mark-read`) // Mark as read
            } else if (this.isGooglePlatformReview(review)) {
              reviewerDetailsAxios = axios.post(`/business/${this.businessSlug}/gmb/reviews/${review.id}/mark-read`) // Mark as read
            } else if (this.isFacebookPlatformReview(review)) {
              reviewerDetailsAxios = axios.post(`/business/${this.businessSlug}/fb/reviews/${review.id}/mark-read`) // Mark as read
            }
          }
          if (this.isProSubscription) {
            if (this.isGooglePlatformReview(review)) {
              notesAxios = axios(`/business/${this.businessSlug}/gmb/reviews/${review.permalink}/notes`) // Fetch team notes
            } else if (this.isFacebookPlatformReview(review)) {
              notesAxios = axios(`/business/${this.businessSlug}/fb/reviews/${review.permalink}/notes`) // Fetch team notes
            } else if (this.isHpPlatformReview(review)) {
              notesAxios = axios(`/business/${this.businessSlug}/reviews/${review.permalink}/notes`) // Fetch team notes
            }
          }

          let [reviewerDetails, notesData] = await Promise.all([reviewerDetailsAxios, notesAxios])
          if (!wasStampedAlready && 'author' in sensitiveData) { // Review was unstamped. If stamping was success then set author details
            reviewerDetails = { data: sensitiveData.author }
          }

          try {
            review.isRead = true

            let author = { canSeeDetails: review.isStamped }
            let ref = ''
            let incidPlace = ''
            if (this.isHpPlatformReview(review) && review.isStamped && 'fullName' in reviewerDetails.data) {
              author = {
                fullName: reviewerDetails.data.fullName,
                id: reviewerDetails.data.id_number,
                email: reviewerDetails.data.email,
                mobile: reviewerDetails.data.phone,
                createdAt: reviewerDetails.data.created_at,
                canSeeDetails: review.isStamped
              }
              ref = this.getIncidentReference(reviewerDetails.data.incident.ref, reviewerDetails.data.incident.id, reviewerDetails.data.incident.acc)
              incidPlace = reviewerDetails.data.incident.branch
            }
            this.reviewDetails[review.permalink] = {
              author,
              ref,
              incidPlace,
              source: (review.source && review.source in this.allSources) ? this.allSources[review.source]['label'] : '',
              replies: {},
              teamNotes: []
            }

            if (!wasStampedAlready && 'replies' in sensitiveData) { // Review was unstamped. If stamping was success then set replies fetched from mysql
              sensitiveData.replies.forEach(reply => {
                this.appendReplyToReview(review.permalink, {
                  id: reply.id,
                  datetime: reply.created_at,
                  body: reply.body,
                  isPrivate: reply.message_type === 2,
                  author: {
                    name: reply.userDisplayName,
                    type: (reply.message_owner === 2) ? 'biz' : 'author'
                  }
                })
              })
            } else if (review.replies.length) { // Review was stamped already. Set replies fetched from elastic
              review.replies.forEach(reply => {
                this.appendReplyToReview(review.permalink, {
                  id: reply.id,
                  datetime: reply.created_at,
                  body: reply.body,
                  isPrivate: reply.private,
                  author: {
                    name: this.calcAuthorName(reply),
                    type: (reply.from_business) ? 'biz' : 'author'
                  }
                })
              })
            }

            if (typeof notesData !== 'undefined' && 'data' in notesData.data) {
              notesData.data.data.forEach(note => {
                this.appendNoteToReview(review.permalink, {
                  author: note.author.name,
                  datetime: this.prettifyDatetime(note.created_at),
                  body: note.message
                })
              })
            }

            review.showDetails = true
            review.loadingDetails = false
          } catch (error) {
            this.displayErrMsg(error, 'Failed to fetch the review details on Review List', `There was an error fetching the review details. Please try again later!`)
          }
        })
      } else {
        review.showDetails = true
        review.loadingDetails = false
      }
    },
    hideReviewDetails (review) {
      review.showDetails = false
    },
    appendReplyToReview (reviewPermalink, replyData) {
      if (reviewPermalink in this.reviewDetails) {
        let type = 'public'
        if ('isPrivate' in replyData && replyData.isPrivate) {
          type = 'private'
        }
        this.reviewDetails[reviewPermalink].replies[`reply-${replyData.id}`] = {
          id: replyData.id,
          editMode: false,
          type,
          author: {
            name: replyData.author.name,
            type: replyData.author.type
          },
          datetime: this.prettifyDatetime(replyData.datetime),
          body: replyData.body
        }
      }
    },

    deleteReply () {
      axios.delete(`/reviews/delete-review-reply/${this.deleteReplyModal.replyId}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.$delete(this.reviewDetails[this.deleteReplyModal.reviewPermalink].replies, `reply-${this.deleteReplyModal.replyId}`)
            this.closeDeleteReplyModal()
          }
        })
        .catch((error) => {
          this.displayErrMsg(error, error.message, `Due to issue, Reply has not been deleted`)
        })
    },
    openDeleteReplyModal (reviewPermalink, replyId) {
      this.deleteReplyModal.show = true
      this.deleteReplyModal.reviewPermalink = reviewPermalink
      this.deleteReplyModal.replyId = replyId
    },
    closeDeleteReplyModal () {
      this.deleteReplyModal.show = false
    },
    showReplyEdit (reply, review) {
      this.editReply[`reply-${reply.id}-${review.permalink}`] = {
        isProcessing: false,
        data: {
          reply: '',
          id: reply.id
        },
        review: {
          permalink: review.permalink,
          id: review.id,
          channel: review.channel
        },
        type: 'editReply'
      }

      reply.editMode = true

      setTimeout(() => {
        this.setWysiwygValue(`editReplyWysiwyg${reply.id}-${review.permalink}`, reply.body)
      }, 100)
      this.updateReplyKey(this.editReply[`reply-${reply.id}-${review.permalink}`])

      this.globalKey++
    },
    postReplyEdit (node, origReply) {
      node.isProcessing = true
      this.updateReplyKey(node)

      if (node.data.reply === origReply.body) {
        this.hideReplyEdit(origReply)
        return false
      }

      let prom
      if (this.isGooglePlatformReview(node.review)) {
        prom = axios.post(`/business/${this.businessSlug}/gmb/reviews/${node.review.id}/replies`, {
          comment: node.data.reply
        })
      } else if (this.isHpPlatformReview(node.review)) {
        prom = axios.put(`/admin/${this.businessSlug}/reviews/${node.review.permalink}/reply/${node.data.id}`, {
          content: node.data.reply
        })
      }

      prom.then(() => {
        node.isProcessing = false

        origReply.body = node.data.reply
        this.hideReplyEdit(origReply)

        flash('Reply has been successfully updated.')
        dataLayer.push({
          'userMessage': {
            'messageType': 'success',
            'messageName': 'Successfully edited review reply on Review Detail',
            'displayedMessage': 'Reply has been successfully updated.'
          }
        })

        if (this.isHpPlatformReview(node.review)) {
          this.recacheReviewDetail([{ bizSlug: this.businessSlug, permalink: node.review.permalink }])
        }
      })
        .catch(() => {
          node.isProcessing = false
          this.updateReplyKey(node)

          let errorMessage = 'There was an error updating the reply. Please try again later!'
          flash(errorMessage, 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to update the review reply on Review Detail',
              'displayedMessage': errorMessage
            }
          })
        })
    },
    hideReplyEdit (reply) {
      reply.editMode = false
      this.globalKey++
    },
    resetNewReplyForm (node, review) {
      this.initReplyNode(node, 'newReply', { permalink: review.permalink, id: review.id, channel: review.channel })

      setTimeout(() => {
        this.setWysiwygValue(`addReplyWysiwyg${review.permalink}`)
      }, 100)
      this.updateReplyKey(node)
    },
    resetReplyPopoverIndex () {
      this.quickReply.openedPopoverIndex = false
    },
    closeReplyPopover () {
      this.quickReply.openedPopoverIndex = -1
      this.$nextTick(() => {
        this.resetReplyPopoverIndex()
      })
    },
    resetQuickReplyForm (review) {
      this.quickReply.openedPopoverIndex = review.id

      this.refreshCanBizReply(review)
        .then(() => {
          if (review.canReply === 'yes') {
            this.initReplyNode(this.quickReply, 'quickReply', {
              permalink: review.permalink,
              id: review.id,
              channel: review.channel
            })
            setTimeout(() => {
              this.setWysiwygValue(`quickReplyWysiwyg${review.permalink}`)
            }, 100)
          }
        })
    },
    postReply (node) {
      if (node.data.reply.trim().length > 0) {
        node.isProcessing = true
        this.updateReplyKey(node)

        let prom
        if (this.isGooglePlatformReview(node.review)) {
          prom = axios.post(`/business/${this.businessSlug}/gmb/reviews/${node.review.id}/replies`, {
            comment: node.data.reply
          })
            .then(({ data }) => {
              data.data.created_at = data.data.created_at.date
              data.data.user = { name: data.data.author.full_name }
              return data.data
            })
        } else if (this.isFacebookPlatformReview(node.review)) {
          prom = axios.post(`/business/${this.businessSlug}/fb/reviews/${node.review.id}/replies`, {
            message: node.data.reply
          })
            .then(({ data }) => {
              data.data.created_at = data.data.created_at.date
              data.data.user = { name: data.data.author.full_name }
              return data.data
            })
        } else if (this.isHpPlatformReview(node.review)) {
          prom = axios.post(`/replies/reviews/${node.review.permalink}`, {
            reply: node.data.reply,
            public: node.data.replyType === 1
          })
            .then(({ data }) => {
              const thisReview = this.reviewsList.items.find(review => {
                return review.permalink === node.review.permalink
              })
              if (!thisReview.isStamped) { // Review was not stamped. We stamped it now
                thisReview.isStamped = data.canSeeSensitive

                if (data.canSeeSensitive) { // If stamping was success, show sensitive data
                  thisReview.body = data.sensitiveData.body
                  thisReview.title = data.sensitiveData.title

                  if (node.review.permalink in this.reviewDetails) { // Biz is replying after opening review details
                    data.sensitiveData.replies.forEach((reply, idx) => {
                      if (typeof thisReview.replies[idx] === 'undefined') { // New reply that did not get shown on UI
                        this.appendReplyToReview(node.review.permalink, {
                          id: data.id,
                          datetime: data.created_at,
                          body: reply.body,
                          isPrivate: node.data.replyType === 2,
                          author: {
                            name: data.user.name,
                            type: 'biz'
                          }
                        })
                      } else {
                        this.reviewDetails[node.review.permalink].replies[`reply-${data.id}`].body = reply.body
                      }
                    })
                  } else { // Biz is replying before opening review details. We will need to make sure previous replies are unmasked
                    data.sensitiveData.replies.forEach((reply, idx) => {
                      if (typeof thisReview.replies[idx] === 'undefined') { // New reply that did not get fetch from elastic
                        thisReview.replies.push({
                          id: data.id,
                          created_at: data.created_at,
                          body: reply.body,
                          private: node.data.replyType === 2,
                          from_business: true,
                          first_name: data.user.name,
                          last_name: ''
                        })
                      } else {
                        thisReview.replies[idx].body = reply.body
                      }
                    })
                  }
                }
              }

              this.recacheReviewDetail([{ bizSlug: this.businessSlug, permalink: node.review.permalink }])
              window.events.$emit('loadHeaderStats')

              return data
            })
        }
        prom.then(data => {
          node.isProcessing = false

          const thisReview = this.reviewsList.items.find(review => {
            return review.permalink === node.review.permalink
          })
          if (thisReview.isStamped || !data.canSeeSensitive) { // Review was stamped already or stamping was a failure
            // We dont need to handle previous replies as they are unmasked already or keep them masked if stamping failed

            let body = data.body
            if (thisReview.isStamped) {
              body = node.data.reply
            }

            if (node.review.permalink in this.reviewDetails) { // Biz is replying after opening review details
              this.appendReplyToReview(node.review.permalink, {
                id: data.id,
                datetime: data.created_at,
                body,
                isPrivate: node.data.replyType === 2,
                author: {
                  name: data.user.name,
                  type: 'biz'
                }
              })
            } else {
              thisReview.replies.push({
                id: data.id,
                created_at: data.created_at,
                body,
                private: node.data.replyType === 2,
                from_business: true,
                first_name: data.user.name,
                last_name: ''
              })
            }
          }

          thisReview.isRead = true
          thisReview.isReplied = true
          thisReview.repliedToComments = true

          if (node.type === 'quickReply') {
            node.openedPopoverIndex = -1
          } else if (node.type === 'newReply') {
            this.resetNewReplyForm(node, {
              permalink: node.review.permalink,
              id: node.review.id,
              channel: node.review.channel
            })
          }

          flash('Your reply has been posted and the reviewer has been notified.')
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully replied to review on Review Detail',
              'displayedMessage': 'Your reply has been posted and the reviewer has been notified.'
            }
          })
        })
          .catch(error => {
            console.log(error, JSON.stringify(error))
            node.isProcessing = false
            this.updateReplyKey(node)

            let errorMessage = 'There was an error replying to this review. Please try again later!'
            if (error.response.data && error.response.data.error) {
              errorMessage = error.response.data.error
            }
            flash(errorMessage, 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to reply to review on Review Detail',
                'displayedMessage': errorMessage
              }
            })
          })
      }
    },
    openModalToChangeReply (node) {
      let options = {
        'title': 'Change this to private reply?',
        'body': 'Your reply contains data that will be masked, and wont be visible to the reviewer when posted. </br></br>Change your reply to private, and allow the reviewer full access to your response.',
        'btn_action_title': 'CHANGE TO PRIVATE',
        'secondary_btn_title': 'KEEP MASKED',
        'show_btns': true,
        'task': 'switchReplyType',
        'keepMaskedDataPublic': true,
        'payload': {
          node
        }
      }
      modal(options)
    },
    switchReplyType (data) {
      data.payload.node.data.replyType = 2
      this.postReply(data.payload.node)
    },
    showMaskingModal (node) {
      if (!this.isFreeSubscription && !this.isGrowthSubscription && node.data.replyType !== 2) {
        if (node.masking.email.length > 0 || (node.masking.phoneNumber.length && node.masking.phoneNumber.some(numb => numb.length > 1))) {
          this.openModalToChangeReply(node)
        } else {
          this.postReply(node)
        }
      } else {
        this.postReply(node)
      }
    },
    getMaskingData (data, node) {
      node.masking.email = (data.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi)) || []
      node.masking.phoneNumber = data.match(/\d+/g) || []
    },
    getCharLength (data, node) {
      this.getMaskingData(data, node)
      this.updateReplyKey(node)
    },
    setWysiwygValue (ref, value = '') {
      if (this.$refs[ref]) {
        const comp = this.$refs[ref][0]
        if (comp) {
          comp.$refs.trix.value = value
        }
      }
    },
    initReplyNode (node, nodeType, review) {
      Object.assign(node, {
        isProcessing: false,
        data: {
          reply: '',
          replyType: 1 // 1 = public, 2 = private
        },
        masking: {
          email: '',
          phoneNumber: ''
        },
        review: {
          permalink: review.permalink,
          id: review.id,
          channel: review.channel
        },
        type: nodeType
      })
    },
    updateReplyKey (node) {
      if (node.type === 'newReply') {
        this.newReply.key += 1
      } else if (node.type === 'editReply') {
        this.editReply.key += 1
      }
    },
    refreshCanBizReply (review, tryCount = 0) {
      if (tryCount < 5) {
        review.checkingCanReply = true
        if (!this.isHpPlatformReview(review)) {
          return new Promise((resolve) => {
            review.canReply = 'yes'
            review.checkingCanReply = false
            resolve()
          })
        } else {
          const prom = axios.get(`/business/${this.businessSlug}/reviews/${review.permalink}/can-reply`)
            .then(data => {
              if ('data' in data.data) {
                review.canReply = 'yes'
              } else {
                review.canReply = 'no'
              }
              review.checkingCanReply = false
            })
            .catch(error => {
              review.canReply = ''
              review.checkingCanReply = false
              this.displayErrMsg(error, 'Failed to fetch if can reply to review on Review List', `There was an error. Please try again later!`)

              flash('Trying again...', 'is-warning')
              setTimeout(() => {
                this.refreshCanBizReply(review, ++tryCount)
              }, 1000)
            })
          return prom
        }
      } else {
        flash('Something is not right. Please report it to us.', 'is-danger')
      }
    },

    copyLink (url) {
      this.$copyText(`${process.env.APP_URL}/review/${url}`)
      flash(`Copied the link to your clipboard`)
    },
    shareOpen (event, permalink) {
      axios.get(`/share-tracking/${event}/${permalink}`)
    },
    createSocialAd (permalink) {
      this.$router.push(`/ads/creator?permalink=${permalink}`)
    },

    clearFilters () {
      this.handleDateChange({
        label: 'last_6_months',
        endDate: null,
        startDate: null
      })
      this.globalKey++
      this.filters.dateFilter.key = `desktop-filter-${this.globalKey}`

      this.statusFilterToggle(false)
      this.ratingFilterToggle(false)
      this.channelFilterToggle(false)
      this.npsFilterToggle(false)

      if (this.isDesktop) {
        this.filterByString(false)
        this.sourceFilterToggle(false)
        this.tagFilterToggle(false)
        this.branchFilterToggle(false)
      } else {
        this.filterDdCbxToggle()
        this.filterDd.key = `touch-filter-${this.globalKey}`
      }
    },
    filterByString (string) {
      if (string === false) {
        this.filters.string = ''
      } else {
        clearTimeout(this.filterByStringTimeoutId)
        this.filterByStringTimeoutId = setTimeout(() => {
          this.filters.string = string
        }, 1000)
      }
    },
    handleDateChange (dateFilter) {
      Object.assign(this.filters.dateFilter, dateFilter)
    },
    unselectTag (tagSlug) {
      const index = this.filters.tags.indexOf(tagSlug)
      if (index !== -1) {
        this.filters.tags.splice(index, 1)
        return true
      }
      return false
    },
    tagFilterToggle (isChecked, tagSlug = '') {
      if (tagSlug) {
        if (isChecked) {
          this.filters.tags.push(tagSlug)
        } else {
          this.unselectTag(tagSlug)
        }
      } else { // Select all
        if (isChecked) {
          this.filters.tags = Object.keys(this.tagsList)
        } else {
          this.filters.tags = []
        }
      }
    },
    unselectBranch (branchSlug) {
      const index = this.filters.branches.indexOf(branchSlug)
      if (index !== -1) {
        this.filters.branches.splice(index, 1)
        return true
      }
      return false
    },
    branchFilterToggle (isChecked, branchSlug = '') {
      if (branchSlug) {
        if (isChecked) {
          this.filters.branches.push(branchSlug)
        } else {
          this.unselectBranch(branchSlug)
        }
      } else { // Select all
        if (isChecked) {
          this.filters.branches = Object.keys(this.branchesList)
        } else {
          this.filters.branches = []
        }
      }
    },
    channelFilterToggle (isChecked, channel = '') {
      if (channel) {
        if (isChecked) {
          this.filters.channel.push(channel)
        } else {
          const index = this.filters.channel.indexOf(channel)
          if (index !== -1) {
            this.filters.channel.splice(index, 1)
          }
        }
      } else if (!isChecked) {
        this.filters.channel = []
      }
    },
    sourceFilterToggle (isChecked, source = '') {
      if (source) {
        if (isChecked) {
          this.filters.source.push(source)
        } else {
          const index = this.filters.source.indexOf(source)
          if (index !== -1) {
            this.filters.source.splice(index, 1)
          }
        }
      } else if (!isChecked) {
        this.filters.source = []
      }
    },
    ratingFilterToggle (isChecked, rating = '') {
      if (rating) {
        if (isChecked) {
          this.filters.rating.push(rating)
        } else {
          const index = this.filters.rating.indexOf(rating)
          if (index !== -1) {
            this.filters.rating.splice(index, 1)
          }
        }
      } else if (!isChecked) {
        this.filters.rating = []
      }
    },
    statusFilterToggle (isChecked, status = '') {
      if (status) {
        if (isChecked) {
          this.filters.status.push(status)
        } else {
          const index = this.filters.status.indexOf(status)
          if (index !== -1) {
            this.filters.status.splice(index, 1)
          }
        }
      } else if (!isChecked) {
        this.filters.status = []
      }
    },
    npsFilterToggle (isChecked, nps = '') {
      if (nps) {
        if (isChecked) {
          this.filters.nps.push(nps)
        } else {
          const index = this.filters.nps.indexOf(nps)
          if (index !== -1) {
            this.filters.nps.splice(index, 1)
          }
        }
      } else if (!isChecked) {
        this.filters.nps = []
      }
    },
    filterDdCbxToggle (targetGroup = '') {
      this.filterDd.options.forEach(opt => {
        if (opt.type === 'checkbox' && (!targetGroup || targetGroup === opt.group)) {
          let filters = []
          if (opt.group === 'status') {
            filters = this.filters.status
          } else if (opt.group === 'starRating') {
            filters = this.filters.rating
          } else if (opt.group === 'channel') {
            filters = this.filters.channel
          } else if (opt.group === 'nps') {
            filters = this.filters.nps
          }

          if (filters.length && filters.includes(opt.value)) {
            opt.checked = true
          } else {
            opt.checked = false
          }
        }
      })
    },

    prettifyDatetime (datetime) {
      // 23 November 2019 at 1:05pm
      return moment(datetime, 'YYYY-MM-DD HH:mm:ss').format('D MMMM YYYY [at] h:mma')
    },
    prettifyDate (datetime) {
      // 25/01/2016
      return moment(datetime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
    },
    calcNpsCat (nps) {
      nps = parseInt(nps)
      if (nps > 8) {
        return 'Promoter'
      }
      if (nps > 6) {
        return 'Passive'
      }
      return 'Detractor'
    },
    isHpPlatformReview (review) {
      return review.channel === 'HELLOPETER'
    },
    isGooglePlatformReview (review) {
      return review.channel === 'GOOGLE'
    },
    isFacebookPlatformReview (review) {
      return review.channel === 'FACEBOOK'
    },
    calcAuthorName (user) {
      if (user.first_name || user.last_name) {
        return `${user.first_name} ${user.last_name}`
      }

      if (this.isGooglePlatformReview(user)) {
        return 'Google User'
      }

      if (this.isFacebookPlatformReview(user)) {
        return 'Facebook User'
      }
    }
  },
  computed: {
    showFacebookPageSelect () {
      return this.multiple_pages.length > 0
    },
    branchesListFirst5 () {
      if (Object.keys(this.branchesList).length <= 5) {
        return this.branchesList
      }

      const first5 = {}
      let i = 0
      for (let branch in this.branchesList) {
        i++
        first5[branch] = this.branchesList[branch]
        if (i >= 5) {
          break
        }
      }
      return first5
    },
    tagsListFirst5 () {
      if (Object.keys(this.tagsList).length <= 5) {
        return this.tagsList
      }

      const first5 = {}
      let i = 0
      for (let tag in this.tagsList) {
        i++
        first5[tag] = this.tagsList[tag]
        if (i >= 5) {
          break
        }
      }
      return first5
    },
    reviewListContHeight () {
      if (this.isReviewDetailPage || this.isDesktop) {
        return 'auto'
      }

      if (this.isTablet) {
        return (window.innerHeight - 250) + 'px'
      }
      return (window.innerHeight - 279) + 'px'
    },
    savedRepliesPopupWidth () {
      if (this.isDesktop) {
        return 704
      }

      if (this.isTablet) {
        return 600
      }

      return 288
    }
  },
  watch: {
    filters: {
      handler (newVal) {
        if (newVal.dateFilter.startDate || newVal.permalink) {
          this.reviewsList.isLoading = true
          this.resetReviewsList()
          this.loadReviewsList(1)
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

.page-layout {
  margin-left: -16px;
  margin-right: -5px;
  font-size: 12px;
  color: #58595b;
}

div.page-info-section {
  margin-bottom: 15px;
  margin-top: 7px;
  position: relative;
}

.page-layout .page-layout-head {
  font-size: 16px;
  margin-left: 21px;
  color: #58595b;
}

.page-layout-horizontal-row {
  margin-bottom: 14px;
}

.page-layout-horizontal-row {
  margin-bottom: 0;
}

.filter-output-section {
  border-right: 1px solid #dbdbdb;
  width: calc(100% - 279px);
}

.filter-output-header {
  padding: 16px 3px 15px 21px;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 15px;
}

.review-detail-page .filter-output-header {
  padding-top: 23px;
  padding-bottom: 22px;
}

.filter-output-header-text {
  font-size: 14px;
  font-weight: bold;
  color: color('blue-dark');
  margin-right: 16px;
}

.filter-output-header-text img {
  width: 100%;
}

.sort-dd {
  max-width: 219px;
}

.sort-dd.custom-dropdown--small >>> .button {
  padding: 8px 0;
}

.sort-dd >>> .button.button-dropdown span {
  font-size: 11px !important;
  color: #58595b;
}

.sort-dd >>> .label-filters {
  font-size: 11px !important;
}

.sort-dd >>> .border-bottom-dbdbdb {
  padding-bottom: 13px !important;
}

.filter-output-body {
  padding: 0 24px 0 20px;
}

.review {
  border-bottom: 1px solid #dbdbdd;
  padding-bottom: 13px;
  margin-bottom: 26px;
}

.review-detail-page .review {
  border: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.review-unread-mark {
  width: 10px;
  height: 10px;
  background-color: color('blue-dark');
  border-radius: 50%;
  margin: 4px 9px 0 1px;
}

.review-title {
  font-size: 14px;
  font-weight: bold;
}

.star-rating-review {
  font-size: 8px;
  width: auto !important;
  margin-left: -3px !important;
  margin-top: 8px !important;
  margin-bottom: 7px;
}

.review-meta {
  margin-left: auto;
  min-width: 150px;
  font-style: italic;
  margin-bottom: 5px;
  font-size: 11px;
}

.review-status-mark {
  border-radius: 14px;
  font-size: 10px;
  color: #ffffff;
  padding: 2px 10px 2px 10px;
  font-style: normal;
  margin-left: 17px;
}

.review-unreplied-mark {
  background-color: #f99c50;
}

.review-replied-mark {
  background-color: #17be86;
}

.review-reported-mark {
  font-style: normal;
  font-size: 10px;
  margin-left: 17px;
}

.review-reported-mark img {
  vertical-align: sub;
  margin-right: 5px;
}

.google-source {
  width: 15px;
}

.non-hp-source {
  vertical-align: middle;
  margin-left: 7px;
  margin-right: 4px;
}

.hp-source {
  margin-left: 6px;
  vertical-align: sub;
  width: 15px;
  margin-right: 6px;
}

.capsule {
  font-size: 11px;
  border-radius: 10px;
  border: solid 1px rgba(88, 89, 91, 0.32);
  padding: 0 1px 1px 7px;
  margin-left: 12px;
}

.capsule--no-del {
  padding-right: 7px;
}

.capsule--fade {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.capsule img {
  vertical-align: sub;
  margin-left: 2px;
}

.review-title-box {
  margin-top: 5px;
}

.review-title-box--has-images {
  margin-top: 15px;
}

.image-list {
  margin-bottom: 14px;
}

.image-list >>> .attachment-thumbnail {
  width: 30px;
  height: 30px;
  margin-right: 7px;
  padding-right: 0;
}

.review-body {
  line-height: 20px;
  margin-top: 8px;
  margin-bottom: 10px;
  width: 100%;
}

.tags-list {
  margin: -12px 0 18px -12px;
}

.report-review {
  color: #58595b;
  margin-top: 17px;
  display: inline-block;
}

.report-review img {
  vertical-align: sub;
}

.review--GOOGLE .report-review {
  opacity: 0.5;
}

.reply-popover .upgrade-msg-monthly {
  margin-bottom: 32px;
}

.reply-popover .has-spinner__spinner {
  width: 15%;
}

.report-popover >>> .alert-box__message-box, .branch-popover >>> .alert-box__message-box {
  font-size: 11px;
}

.tag-popover .field.is-grouped > .control:not(:last-child) {
  margin-right: 15px;
}

.edit-tag-popover__para {
  margin: 14px 0 9px;
}

.edit-tag-popover__msg {
  font-size: 12px;
  margin: 5px 0 4px;
}

.edit-tag-popover__msg--hidden {
  visibility: hidden;
}

.tag-popover .solid-btn {
  font-size: 12px;
  padding: 9px 40px;
}

.edit-tag-popover .solid-btn {
  padding: 9px 27px 7px;
}

.branch-popover .solid-btn {
  padding: 9px 27px;
}

.add-note-popover >>> .popover-new-head {
  margin-bottom: 14px;
}

.review-action-btn {
  border-radius: 12.5px;
  border: 1px solid color('blue');
  color: color('blue');
  font-weight: 600;
  margin-right: 12px;
  padding: 3px 0 2px;
  text-align: center;
  width: 90px;
  display: inline-block;
  margin-bottom: 10px;
}

.v-popover.open .review-action-btn {
  background-color: color('blue');
  color: #ffffff;
}

.review-details-box {
  background-color: #f7f7f7;
  padding: 11px 19px 19px 19px;
  margin-top: 4px;
  margin-bottom: 10px;
}

.review-details-header {
  padding-right: 4px;
  margin-bottom: 13px;
}

.review-author-details {
  margin-bottom: 20px;
  padding: 12px 14px 14px;
  background-color: #fcfcfc;
}

.review-author-details .upgrade-msg {
  padding: 52px 0 50px 6px;
}

.review-author-details .upgrade-msg-monthly {
  padding: 35px 0 33px 1px;
}

.review-author-details .upgrade-msg-annually {
  padding: 10px 0 8px 1px;
}

.review-author-detail-col {
  font-weight: bold;
  width: 109px;
  margin-bottom: 2px;
}

.biz-reply {
  border-left: 1px solid #c4c4c5;
  margin-left: 6px;
  margin-right: 2px;
  padding-top: 7px;
  padding-left: 15px;
  padding-bottom: 6px;
  margin-bottom: 34px;
}

.author-reply {
  margin-bottom: 34px;
  margin-right: 2px;
}

.biz-reply:last-child {
  margin-bottom: 31px;
}

.reply-type-capsule {
  font-size: 10px;
  background-color: #58595b;
  color: #fff;
  font-weight: normal;
  margin-left: 14px;
}

.author-reply:last-child {
  margin-bottom: 26px;
}

.reply-box {
  background-color: #fcfcfc;
  padding: 15px 15px 15px 18px;
  margin-bottom: 20px;
}

.reply-box .upgrade-msg {
  padding: 30px 0 34px;
}

.reply-box .upgrade-msg-annually {
  padding: 7px 0;
}

.wysiwyg {
  border-color: #c9c9ca;
  margin: 4px 0 15px;
}

.wysiwyg >>> .trix-button-row {
  background-color: #fff !important;
  border-bottom: 1px solid #c9c9ca;
}

.wysiwyg >>> trix-toolbar .trix-button-group {
  margin-top: 5px !important;
  margin-bottom: 4px;
  padding-left: 6px;
}

.wysiwyg >>> trix-toolbar .trix-button--icon-bold {
  width: 15px;
  margin-right: 3px;
}

.wysiwyg >>> trix-toolbar .trix-button--icon-italic {
  width: auto;
  margin-right: 3px;
}

.wysiwyg >>> trix-toolbar .trix-button--icon-bullet-list, .wysiwyg >>> trix-toolbar .trix-button--icon-number-list {
  width: 21px;
  margin-right: 3px;
}

.wysiwyg >>> trix-toolbar .trix-button--icon-bullet-list::before, .wysiwyg >>> trix-toolbar .trix-button--icon-number-list::before {
  width: 15px;
  left: 3px;
}

.wysiwyg >>> trix-editor {
  padding: 10px;
  min-height: 86px;
}

.wysiwyg >>> trix-editor:empty:not(:focus)::before {
  color: rgba(88, 89, 91, 0.32);
}

.saveReplyBubble {
  position: absolute;
  top: 6px;
  right: 9px;
}

.review-notes-head {
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid #dbdbdd;
  padding-bottom: 4px;
}

.review-note {
  border-bottom: 1px solid #dbdbdd;
  padding: 14px 0 20px;
}

.filter-section {
  width: 294px;
  margin-right: -15px;
  padding-bottom: 24px;
}

.filter-search-module {
  background-color: #fafafa;
  padding: 16px 15px 19px 17px;
  border-bottom: 1px solid #dbdbdb;
}

.filter-search-module-foot {
  padding-left: 1px;
  padding-top: 20px;
}

.filter-date-module {
  padding: 11px 15px 0 17px;
}

.filter-date-module .custom-dropdown {
  padding-left: 0;
  margin-right: 0;
  width: 100%;
  margin-top: 14px;
}

.filter-module-with-checkbox {
  padding: 13px 16px 0 15px;
}

.filter-module-with-checkbox .checkbox {
  margin-left: 3px !important;
  margin-bottom: 9px !important;
}

.filter-module-with-checkbox .checkbox-label, .branch-filter-popover .checkbox-label {
  margin-left: 9px;
  font-size: 12px;
  font-weight: normal;
}

.filter-status-module {
  padding-top: 30px
}

.filter-star-module .level-right {
  margin-top: -8px;
  padding-right: 22px;
}

.star-rating-filter {
  width: 60px !important;
  display: inline-block;
  position: absolute;
  top: 3px;
  left: 69px;
}

.filter-module-with-checkbox .blue-link {
  margin: 0 0 8px 4px;
  display: inline-block;
}

.branch-filter-popover {
  padding-left: 31px !important;
}

.branch-filter-popover .select-all {
  margin-top: -18px;
  margin-bottom: 12px;
}

.branch-filter-popover__list {
  max-height: 272px;
  overflow-y: auto;
}

.branch-filter-popover__list::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Handle */
.branch-filter-popover__list::-webkit-scrollbar-thumb {
  background: #bcbec0;
  border-radius: 10px;
}

.branch-filter-popover__list > .column {
  width: 168.2px;
  display: inline-block;
  padding: 0 18px 0 0;
}

.branch-filter-popover__list > .column:nth-child(5) {
  padding-right: 0;
  width: 150.2px;
}

.export-module {
  padding: 9px 0 0 19px;
}

.export-module-head {
  font-weight: bold;
  margin-bottom: 9px;
}

.export-module .export-btn {
  margin-top: 19px;
  margin-right: 32px;
}

#userHistoryModal .modal-close-link {
  right: 15px;
  top: 13px;
}

#userHistoryModal .modal-card-head {
  padding: 19px 0 15px 35px;
}

#userHistoryModal .modal-card-head-title {
  font-size: 14px;
  text-align: left;
  margin-bottom: 0;
}

#userHistoryModal .modal-card-body {
  padding: 0 23px 16px 24px;
}

#userHistoryModal .level {
  padding-left: 11px;
  padding-right: 7px;
}

#userHistoryModal >>> .acc-head {
  padding-left: 11px;
}

#userHistoryModal .review-card {
  padding: 0 7px 20px 11px;
  border-bottom: 1px solid #dbdbdd;
  margin-bottom: 16px;
}

.modal .hollow-btn {
  padding-left: 42px;
  padding-right: 42px;
  margin-right: 5px;
  margin-top: 24px;
}

.modal .solid-btn {
  font-size: 12px;
  padding: 9px 44px;
  margin-top: 23px;
}

#deleteReplyModal .modal-card {
  max-width: 336px;
  height: 177px;
}

#deleteReplyModal .modal-card-head, #deleteTagModal .modal-card-head {
  padding-top: 16px;
  padding-bottom: 0;
}

#deleteReplyModal .modal-card-body {
  padding: 0;
}

#deleteTagModal .modal-card {
  height: 344px;
  max-width: 336px;
}

#deleteTagModal .modal-card-head-title {
  margin-bottom: 18px;
}

#deleteTagModal .modal-card-body {
  padding-left: 32px;
  padding-right: 26px;
  line-height: 20px;
}

#deleteTagModal ul {
  list-style: inside;
}

/* Tablet */
@media screen and (min-width: 768px) and (max-width: 991px) {
  #newReviewList {
    margin-left: -20px;
    margin-right: -20px;
  }

  #newReviewList.page-layout .page-layout-head {
    font-size: 14px;
    margin-top: 13px;
    margin-bottom: 2px;
    margin-left: 16px;
  }

  .custom-dropdown {
    width: 292px;
  }

  .filter-section--tablet .blue-link {
    margin: 20px 0 0 9px;
  }

  #newReviewList .filter-output-header {
    border: none;
    padding-top: 15px;
    padding-bottom: 14px;
  }

  .review {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 17px;
  }

  .review > .is-flex {
    padding: 0 24px 0 20px;
  }

  .star-rating-review >>> li {
    font-size: 1.5em;
  }

  .review-meta {
    min-width: 135px;
  }

  .review-title-box {
    margin-top: 27px;
  }

  .review-title-box--has-images {
    margin-top: 33px;
  }

  .image-list {
    margin-bottom: 9px;
  }

  .review-body {
    margin-bottom: 0;
  }

  .review-separator {
    padding: 15px 24px 0 20px;
  }

  .review-separator div {
    border-bottom: 1px solid #dbdbdd;
  }

  .review-details-box {
    margin-top: 11px;
    padding-bottom: 16px;
    margin-bottom: 0;
  }

  .reply-box .field:not(:last-child) {
    margin-bottom: 0;
  }

  .review-author-details .upgrade-msg {
    font-size: 11px;
  }

  .reply-box .upgrade-msg {
    padding: 67px 0 66px 28px;
  }

  .review-author-details .upgrade-msg-monthly {
    padding: 32px 0 30px 10px;
  }

  .review-author-details .upgrade-msg-annually {
    padding: 6px 0 8px 11px;
  }

  .reply-box .upgrade-msg-annually {
    padding-top: 20px;
    padding-left: 6px;
    padding-bottom: 26px;
  }

  .reply-box .upgrade-msg-annually >>> .input-row {
    margin-top: 19px;
  }

  .filter-dd {
    margin-top: 12px;
  }
}

/* Tablet and mobile */
@media screen and (max-width: 991px) {
  .filter-output-section {
    width: 100%;
    border: none;
  }

  .filter-section--tablet {
    padding: 4px 0 17px 8px;
  }

  .filter-output-header {
    background-color: #f7f8f8;
  }

  .filter-output-body {
    padding: 0;
    height: var(--height);
    overflow-y: auto;
  }

  .review-details-box {
    border-top: solid 1px #dbdbdb;
  }

  .review-author-details .upgrade-msg img {
    vertical-align: bottom;
    margin-right: 7px !important;
  }

  .reply-box .upgrade-msg {
    font-size: 11px;
  }

  .reviewPagination {
    margin-right: 0;
  }

  #reportReviewModal .modal-card {
    max-width: 320px;
    height: 480px;
  }

  #reportReviewModal .modal-card-head {
    padding: 6px 17px 9px 17px;
  }

  #reportReviewModal .modal-close-link {
    right: 14px;
    top: 12px;
  }

  #reportReviewModal .modal-card-head-title {
    text-align: left;
    font-size: 14px;
    margin-bottom: 0;
  }

  #reportReviewModal .modal-card-body {
    padding: 0 21px 16px 17px;
  }

  #reportReviewModal .solid-btn {
    margin-top: 10px;
  }

  .filter-dd >>> .star-rating-filter {
    position: absolute;
    top: 6px;
    left: 65px;
  }

  .filter-dd >>> .star-rating-count {
    width: 193px;
    display: inline-block;
    text-align: right;
  }

  .filter-dd >>> .nps-count {
    width: 102px;
    display: inline-block;
    text-align: right;
  }
}

/* Mobile */
@media screen and (max-width: 767px) {
  #newReviewList {
    margin-left: 0;
    margin-right: 0;
  }

  div.page-info-section {
    margin-bottom: 1px;
  }

  #newReviewList.page-layout .page-layout-head {
    font-size: 11px;
    margin-top: 26px;
    margin-left: 20px;
  }

  .filter-section--tablet {
    padding-left: 2px;
    padding-bottom: 11px;
    width: 320px;
  }

  .custom-dropdown {
    width: 305px;
    padding-top: 5px;
  }

  .filter-section--tablet .blue-link {
    margin: 7px 18px 0 0;
  }

  #newReviewList .filter-output-header {
    padding-top: 12px;
    padding-right: 17px;
    padding-bottom: 10px;
    margin-bottom: 12px;
  }

  .filter-output-header-text {
    font-size: 12px;
  }

  .review {
    margin-bottom: 18px;
  }

  .review > .is-flex {
    padding: 0 18px 0 19px;
  }

  .review-unread-mark {
    margin-top: 3px;
  }

  .star-rating-review {
    margin-top: 1px !important;
    margin-bottom: 5px;
  }

  .star-rating-review >>> li {
    font-size: 1.4em;
  }

  .review-title {
    font-size: 12px;
  }

  .review-status-mark {
    margin-left: 0;
  }

  .review-title-box {
    margin-top: 13px;
  }

  .review-title-box--has-images {
    margin-top: 13px;
  }

  .image-list {
    order: 2;
    margin-bottom: 5px;
  }

  .review-body {
    margin-bottom: 1px;
    margin-top: 3px;
  }

  .report-review {
    margin-top: 15px;
  }

  .review-details-box {
    margin-top: 19px;
    padding-top: 15px;
  }

  .review-author-details {
    font-size: 11px;
  }

  .review-author-details .upgrade-msg {
    padding-left: 1px;
    padding-top: 30px;
    padding-bottom: 28px;
  }

  .review-author-details .upgrade-msg-monthly {
    padding-top: 5px;
    padding-bottom: 4px;
    margin: 0 -10px;
  }

  .review-author-details .upgrade-msg-annually {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .reply-box .upgrade-msg-annually {
    padding: 26px 10px 4px;
  }

  .reply-box >>> .net-amount {
    margin-left: 6px;
  }

  .reply-box >>> .input-row .blue-link {
    margin-right: 7px;
  }

  .biz-reply .level-left.font-size-14, .author-reply .level-left.font-size-14 {
    font-size: 12px !important;
  }

  .biz-reply .level-right.is-italic, .author-reply .level-right.is-italic {
    font-size: 11px;
    margin-top: 1px;
  }

  .reply-box {
    margin-left: -19px;
    margin-right: -19px;
    margin-bottom: 13px;
  }

  .reply-box .upgrade-msg {
    text-align: center;
    padding-top: 26px;
    padding-left: 1px;
    padding-bottom: 24px;
  }

  .reply-box > .font-size-14 {
    font-size: 12px !important;
  }

  .reply-box .button.solid-btn {
    width: 100%;
  }

  .review-notes-head {
    font-size: 12px;
  }

  .review-note .level-right {
    margin-top: 0;
    font-size: 11px;
  }

  #deleteReplyModal .modal-card {
    margin: 0 16px;
    height: 147px;
  }

  #deleteReplyModal .modal-card-head-title {
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 11px;
  }

  #deleteReplyModal .hollow-btn {
    margin-right: 6px;
    margin-top: 17px;
    font-size: 12px;
  }

  #deleteReplyModal .solid-btn {
    margin-top: 17px;
  }

  .reply-type-capsule {
    margin-left: 6px;
  }
}

.star-rating-review >>> img {
  height: 14px;
}
</style>

<style>
#newReviewList .popover-new-container {
  top: -8px !important;
}

#newReviewList .reply-popover {
  left: 320px !important;
}

#newReviewList .add-note-popover {
  left: -11px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/reviews/BusinessReviewsListNew.vue